/**********************************************************/
/* WooCommerce JS Start ***********************************/
/**********************************************************/
const $ = require('jquery');

module.exports = {
  init_woocommerce: function() {
    moveFilterForm();
    setCartTrayPosition();
    checkoutStyles();
    // initStockStatusToggle();  // Disabled — let WCAPF render its native
    //                             // checkbox layout for the _stock_status
    //                             // filter. The toggle override forced the
    //                             // filter into a single instock toggle and
    //                             // discarded the multi-option (instock /
    //                             // outofstock / onbackorder) UI.
    limitFiltersWithToggle();
    addProductPerPageField();
    updateInstockText();
    layoutCookie();
    hideEmptyWcapfFilters();
    shortDescriptionToggle();
    stickyFilterHeight();
    injectSubfilterToggles(); // #2 — collapse nested sub-filters on first load (desktop + mobile)
    // Defer to the next tick so WCAPF.init() has finished binding its
    // own `.on('input', ...)` listeners before we unbind and replace them.
    setTimeout(debouncePriceFilterInputs, 0);
    // adjustTrustpilotWidgetMargin();

    var resizeTimer;
    $(window).on("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        moveFilterForm();
        setCartTrayPosition();
        checkoutStyles();
        limitFiltersWithToggle();
        moveMultiBuyBtn();
        stickyFilterHeight();
      }, 150);
    });

    $(document).ajaxComplete(function() {
      setTimeout(updateInstockText, 100);
      setTimeout(layoutCookie, 100);
      setTimeout(hideEmptyWcapfFilters, 100);
      // setTimeout(adjustTrustpilotWidgetMargin, 100);

      // Trustpilot widget reinit — routed through the single idempotent
      // helper below. Previously we called `loadFromElement(this, true)`
      // here AND in two other places (MutationObserver + wcapf_after_updating_products)
      // which meant each widget got force-reloaded 2–3× per AJAX cycle,
      // visibly flickering on screen as iframes were torn down and
      // rebuilt. `refreshTrustpilotWidgets` dedupes via a DOM marker
      // so each widget is only rendered once per fresh DOM instance.
      refreshTrustpilotWidgets();
    });

    // Trustpilot init helper. Called from three places:
    //   - `ajaxComplete` (above) for jQuery-driven AJAX
    //   - `reinitProductWidgets` (below) when a MutationObserver detects
    //     WCAPF swapping in fresh product cards
    //   - `wcapf_after_updating_products` event handler (below)
    //
    // The previous version of this file called `loadFromElement(el, true)`
    // in all three sites independently, so every WCAPF filter / pagination
    // hit would force-reload every visible widget twice. The `true` flag
    // tells Trustpilot to destroy the existing iframe and rebuild — useful
    // exactly once per fresh DOM element, ruinous when called repeatedly.
    //
    // Dedup mechanism: tag each widget with `data-tp-init="1"` immediately
    // after calling loadFromElement. WCAPF's DOM swap wipes the attribute
    // along with the rest of the element, so freshly-injected widgets
    // pass the check on the next reinit pass and get rendered exactly
    // once. The marker is removed if loadFromElement throws so the next
    // tick retries.
    //
    // Additionally, widgets that Trustpilot's external bootstrap rendered
    // on initial page load (before this helper runs) are flagged as
    // "already mounted" via the iframe-presence check, so we don't
    // force-reload them on the first AJAX cycle and trigger a flicker.
    function refreshTrustpilotWidgets() {
      if (!window.Trustpilot) return;
      $('.trustpilot-widget').each(function () {
        var widget = this;
        if (widget.getAttribute('data-tp-init') === '1') return;

        // Trustpilot's own scanner ran on page load and rendered an
        // iframe inside this widget. Mark it so future reinit passes
        // skip it, but don't force-reload — the iframe is already live.
        if (widget.querySelector('iframe')) {
          widget.setAttribute('data-tp-init', '1');
          return;
        }

        widget.setAttribute('data-tp-init', '1');
        try {
          window.Trustpilot.loadFromElement(widget, true);
        } catch (e) {
          widget.removeAttribute('data-tp-init');
        }
      });
    }

    // Feefo widget reinit — the Feefo equivalent of
    // refreshTrustpilotWidgets above. WCAPF's AJAX swap (sort change,
    // filters, pagination) replaces the product grid, and Feefo's
    // bootstrap only scans the DOM when its script loads — the fresh
    // card shells never hydrate, so the stars vanish (Liam's repro,
    // Jul 2026). Feefo exposes no public re-scan API (FeefoLoader's
    // constructor needs internal state), but re-appending the script
    // re-runs the bootstrap scan and hydrates any unprocessed shells —
    // verified on staging.
    //
    // Dedup: shells Feefo has processed carry a shadowRoot; we mark
    // everything we've seen with `data-ff-init` (WCAPF's swap wipes
    // the marker with the element, so fresh shells re-qualify). The
    // script is only re-appended when at least one genuinely
    // unprocessed shell exists.
    //
    // Settle window: Feefo's INITIAL hydration mutates the grid, which
    // trips the product-list MutationObserver into this helper while
    // sibling shells are still mid-hydration — without the guard we'd
    // double-load the script on every normal page view (and racing
    // scans can attachShadow twice on one shell, which throws). WCAPF
    // interactions inside the first 8s are unrealistic; anything after
    // is a real swap.
    var __acityFeefoSettleUntil = Date.now() + 8000;
    function refreshFeefoWidgets() {
      if (Date.now() < __acityFeefoSettleUntil) return;
      var pending = false;
      $('.feefo-product-stars-widget').each(function () {
        if (this.getAttribute('data-ff-init') === '1') return;
        if (this.shadowRoot) {
          this.setAttribute('data-ff-init', '1');
          return;
        }
        this.setAttribute('data-ff-init', '1');
        pending = true;
      });
      if (!pending) return;
      var script = document.createElement('script');
      script.src = 'https://api.feefo.com/api/javascript/appliance-city-ltd';
      script.async = true;
      document.body.appendChild(script);
    }

    /* -- Youreko listing rescue -----------------------------------------
     *
     * Youreko's partner script has a destructive bug on listing pages:
     * configureEkoGroup() looks up
     * metadata.general.hasEkoGroupAttribute[productData.productType] and,
     * when falsy, runs a GLOBAL $(".youreko-has-ekogroup").remove().
     * Products their API doesn't recognise come back as
     * {productFound:false} with NO productType, so the lookup is
     * hasEkoGroupAttribute[undefined] -> falsy -> every previously
     * rendered widget on the page is wiped. Net result: the listing ends
     * with widgets only if the LAST processed product happened to be a
     * found one — which is why staging showed none and local sometimes
     * showed one (traced Jul 2026 via stack-capture on their remove()).
     *
     * Their `metadata` property is assigned from the API response during
     * handling, and it's public — so we intercept the assignment and
     * wrap hasEkoGroupAttribute in a Proxy that answers `true` for any
     * key NOT in the map. Real product types keep their real values;
     * the undefined-type lookup stops hitting the destructive branch
     * (its else-arm removes ".youreko-no-ekogroup", which never exists
     * here). Reported to Youreko for a proper upstream fix.
     */
    (function acityYourekoListingRescue() {
      if (typeof Proxy !== 'function') return;
      var applied = false;
      function wrapMeta(v) {
        try {
          if (v && v.general && v.general.hasEkoGroupAttribute) {
            v.general.hasEkoGroupAttribute = new Proxy(v.general.hasEkoGroupAttribute, {
              get: function (t, k) { return (k in t) ? t[k] : true; },
            });
          }
        } catch (e) { /* leave metadata untouched on any surprise */ }
        return v;
      }
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        if (tries > 400) { clearInterval(iv); return; } // ~20s, script not on this page
        var retriever = window.Youreko && window.Youreko.EnergyLabelRetriever;
        if (!retriever || applied) { if (applied) clearInterval(iv); return; }
        applied = true;
        clearInterval(iv);
        var current = wrapMeta(retriever.metadata);
        try {
          Object.defineProperty(retriever, 'metadata', {
            configurable: true,
            get: function () { return current; },
            set: function (v) { current = wrapMeta(v); },
          });
        } catch (e) { /* defineProperty blocked — worst case, original behaviour */ }
      }, 50);
    })();

    /* -- Attribute-content page URL cleaner ------------------------------
     *
     * The server seeds the page's implicit category/attribute into
     * WCAPF's state (so the checkboxes render ticked), and WCAPF then
     * writes those params into every URL it pushes — filtering by
     * Colour on /dishwashers/freestanding-dishwashers/miele/ produced
     * ?product-cat=freestanding-dishwashers&brand=miele&colour=white,
     * and removing Colour left the seeds behind (Beckie's URL-bloat
     * report, Jul 2026). The clean page URL already encodes the seeded
     * context, so we wrap pushState/replaceState and strip any param
     * that exactly matches its seed. If the customer removes part of
     * the base context itself (unticks Miele on the Miele page), the
     * page no longer represents the filter state — we navigate to the
     * parent category with whatever filters remain instead.
     */
    (function acityAttrUrlClean() {
      var tag = document.getElementById('ac-attr-seeded-context');
      if (!tag || !window.URL || !window.URLSearchParams) return;
      var data;
      try { data = JSON.parse(tag.textContent); } catch (e) { return; }
      var seeded = (data && data.seeded) || {};
      var keys = Object.keys(seeded);
      if (!keys.length) return;
      var navigating = false;

      // Strip params that exactly match the page's seeded context —
      // the clean term URL already encodes them. Combined selections
      // (comma-joined values) keep their full param: the server only
      // seeds a key when it's ABSENT from the request, so stripping one
      // value out of a list would change what a reload shows.
      function clean(rawUrl) {
        var u;
        try { u = new URL(String(rawUrl), window.location.href); } catch (e) { return rawUrl; }
        keys.forEach(function (k) {
          [k, k + '[]'].forEach(function (name) {
            var vals = u.searchParams.getAll(name);
            if (vals.length === 1 && vals[0] === seeded[k]) {
              u.searchParams.delete(name);
            }
          });
        });
        var qs = u.searchParams.toString();
        return u.pathname + (qs ? '?' + qs : '') + u.hash;
      }

      ['pushState', 'replaceState'].forEach(function (fn) {
        var orig = history[fn];
        history[fn] = function (state, title, url) {
          if (url == null || navigating) return orig.apply(this, arguments);
          return orig.call(this, state, title, clean(url));
        };
      });

      // Removing part of the base context itself (unticking Miele on
      // the Miele page) means this page no longer represents the filter
      // state — send the customer to the parent category with whatever
      // OTHER filters are in the (already cleaned) address bar. Watched
      // at the input rather than inferred from URLs: after the first
      // clean, WCAPF's pushed URLs omit the seeds entirely, so a
      // missing param can't distinguish "removed colour" from "removed
      // the brand".
      document.addEventListener('change', function (e) {
        var input = e.target;
        if (navigating || !input || input.type !== 'checkbox' || input.checked) return;
        if (!input.closest('[class*="wcapf"]')) return;
        var key = String(input.name || '').replace(/\[\]$/, '');
        if (!(key in seeded) || String(input.value) !== String(seeded[key])) return;
        if (!data.category_url) return;
        navigating = true;
        var params = new URLSearchParams(window.location.search);
        keys.forEach(function (k) { params.delete(k); params.delete(k + '[]'); });
        var qs = params.toString();
        window.location.href = data.category_url + (qs ? '?' + qs : '');
      }, true);
    })();

    /* -- Filter click → attribute-content landing page ------------------
     *
     * On a CLEAN category page (no filters active), selecting a filter
     * whose value has a curated attribute-content landing page navigates
     * there instead of filtering in place — e.g. Width 55cm on
     * /washing-machines/ goes to /laundry/washing-machines/55cm/ (client
     * brief, Jul 2026). The map is emitted server-side by
     * inc/_attr-content-filter-routing.php on clean product_cat archives
     * only; once any filter is active (checked per event, because WCAPF
     * applies filters via pushState without a reload) selections behave
     * as normal WCAPF filtering.
     *
     * Capture phase so we run before WCAPF's own change handlers;
     * stopPropagation keeps its AJAX from firing for the click we're
     * turning into a navigation.
     */
    (function acityAttrFilterRouting() {
      var tag = document.getElementById('ac-attr-filter-route-map');
      if (!tag) return;
      var data;
      try { data = JSON.parse(tag.textContent); } catch (e) { return; }
      if (!data || !data.map) return;
      var KEYS = data.keys || [];

      function urlHasAnyFilter() {
        var params = new URLSearchParams(window.location.search);
        for (var i = 0; i < KEYS.length; i++) {
          if (params.has(KEYS[i]) || params.has(KEYS[i] + '[]')) return true;
        }
        return false;
      }

      document.addEventListener('change', function (e) {
        var input = e.target;
        if (!input || (input.type !== 'checkbox' && input.type !== 'radio')) return;
        if (!input.checked) return;
        if (!input.closest('[class*="wcapf"]')) return;
        if (urlHasAnyFilter()) return;

        // Facet input names render both bare ("width") and array
        // ("width[]") depending on WCAPF's render mode.
        var key = String(input.name || '').replace(/\[\]$/, '');
        var slugMap = data.map[key];
        if (!slugMap) return;
        var url = slugMap[String(input.value)];
        if (!url) return;

        e.preventDefault();
        e.stopPropagation();
        window.location.href = url;
      }, true);
    })();

    // Youreko re-scan for WCAPF swaps — their retriever only scans the
    // DOM when its bootstrap runs, so cards swapped in by sorting /
    // filtering / pagination never get energy widgets. Their partner
    // module exposes the full re-run; safe no-op off listing pages.
    function refreshYourekoWidgets() {
      try {
        var mod = window.Youreko
          && window.Youreko.EnergyLabelRetriever
          && window.Youreko.EnergyLabelRetriever.ApplianceCity;
        if (mod && typeof mod.getEnergyLabels === 'function') {
          mod.getEnergyLabels();
        }
      } catch (e) { /* their internals threw — nothing we can do */ }
    }

    // Strip the Product JSON-LD node Feefo's review widget appends to
    // <body> (script id "onpage-product-schema-<uuid>"). The PDP's
    // aggregateRating now lives server-side inside WooCommerce's own
    // Product node (inc/_feefo-widgets.php — Neil's schema spec, Jul
    // 2026); Feefo's extra node would give Google two Product blocks
    // with independently-sourced rating values that can drift apart
    // across our daily cache window. One authoritative node only.
    //
    // Feefo appends it once during widget render (no re-injection
    // observer on their side), so a MutationObserver watching for the
    // script id is enough. Scoped to product pages — the node is only
    // injected where the review widget renders.
    (function stripFeefoProductSchema() {
      if (!document.body || !document.body.classList.contains('single-product')) return;
      var removeNodes = function () {
        var nodes = document.querySelectorAll('script[id^="onpage-product-schema-"]');
        for (var i = 0; i < nodes.length; i++) {
          nodes[i].parentNode.removeChild(nodes[i]);
        }
        return nodes.length > 0;
      };
      removeNodes();
      var observer = new MutationObserver(function () {
        if (removeNodes()) {
          // Feefo injects exactly once — job done, stop observing.
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true });
    })();

    // Self-contained replacement for the wt-woocommerce-wishlist
    // plugin's click handler. The plugin binds via `$.click()` (direct,
    // not delegated) inside its own `$(document).ready`, which means
    // every wishlist button inserted into the DOM by WCAPF AJAX (or
    // any other dynamic replacement) ends up with zero click handler
    // and looks broken to the customer.
    //
    // Replicating the AJAX call here as a document-delegated handler
    // makes wishlist add / remove work for any current OR future
    // `.wt-wishlist-button` automatically, regardless of how the
    // button got into the DOM. Visual toggle (icon swap, class flip)
    // is handled by the existing delegated handler further down — we
    // strip the plugin's direct binding here so it doesn't fire the
    // AJAX twice on the buttons the plugin DID manage to bind.
    setTimeout(function () {
      $('.wt-wishlist-button').off('click');
    }, 800);

    $(document).off('click.acityWishlistAjax', '.wt-wishlist-button')
               .on('click.acityWishlistAjax', '.wt-wishlist-button', function (e) {
      var ajax = window.wbte_wishlist_ajax_add;
      if ( ! ajax ) return; // plugin not loaded — nothing to call

      e.preventDefault();

      var $elm        = $(this);
      var product_id  = $elm.data('product_id');
      var variationEl = document.querySelector('input[name=variation_id]');
      var variation_id = variationEl ? variationEl.value : '';
      var action      = $elm.attr('data-action') || 'add';
      var qtyEl       = document.querySelector('input[name=quantity]');
      var quantity    = (qtyEl && qtyEl.value) ? qtyEl.value : 1;

      // Show the loader image. Mirrors the plugin's per-tag handling
      // (img / i / span sibling structures).
      var tag = this.tagName.toLowerCase();
      if ( tag === 'img' ) {
        $elm.attr('src', ajax.wishlist_loader).css({ height: '15px' });
      } else if ( tag === 'i' ) {
        $elm.children('img').attr('src', ajax.wishlist_loader);
      } else if ( $elm.prev().is('img') ) {
        $elm.siblings('img').attr('src', ajax.wishlist_loader).css({ height: '15px' });
      }

      $.ajax({
        url: ajax.add_to_wishlist,
        type: 'POST',
        data: {
          action: 'add_to_wishlist',
          product_id: product_id,
          variation_id: variation_id,
          act: action,
          quantity: quantity,
          wt_nonce: ajax.wt_nonce
        },
        success: function (response) {
          var newAction = (action === 'remove' ? 'add' : 'remove');
          // Flip the data-action on every button referring to this product
          // so subsequent clicks go the other way.
          $('.wt-wishlist-button[data-product_id="' + product_id + '"]').attr('data-action', newAction);

          // Swap the icon to the post-toggle state (response carries the
          // image URL based on the new action).
          var iconUrl = response && (response.img_change_url_icon || response.img_change_url);
          if ( iconUrl ) {
            $('.wt-wishlist-button[data-product_id="' + product_id + '"]').each(function () {
              var $b = $(this);
              if ( $b.is('img') ) {
                $b.attr('src', iconUrl).css({ height: '' });
              } else if ( $b.is('i') ) {
                $b.children('img').attr('src', iconUrl);
              } else {
                $b.siblings('img').attr('src', iconUrl);
              }
            });
          }
        }
      });
    });

    // Track when a WCAPF update was triggered by pagination so we can scroll
    // the user back to the top of the shop block. WCAPF intercepts the
    // standard `woocommerce_pagination` links and AJAX-replaces the product
    // grid in place, which would otherwise leave the user anchored at the
    // bottom of the previous page after clicking "next".
    var paginationScrollPending = false;

    $(document).on('click', '.standard-woocommerce-shop .woocommerce-pagination a, .standard-woocommerce-shop .wcapf-pagination a', function() {
      paginationScrollPending = true;
    });

    // Full-reload pagination (e.g. /page/2/?s=oven on the search render,
    // or any non-AJAX paged URL) — anchor the user at the top of the
    // shop block on the new page. The sticky header overlays the
    // first ~160px of viewport on this site, so the shop block sits
    // just below it once scrollY = 0 — and that's the position we
    // want pagination to land on.
    //
    // Most browsers scroll-to-top on a fresh navigation, but two
    // gotchas:
    //   1. Some sticky-header / promo-bar layouts shift the body
    //      height after first paint and leave the viewport scrolled
    //      partway down when the user expected the top.
    //   2. Mobile Safari back-forward cache can preserve the
    //      previous page's scroll Y.
    //
    // Belt + braces: disable native scroll restoration on these
    // pages, then force scrollTo(0,0) at four progressively later
    // checkpoints (DOM ready, rAF, 100ms, load). The work is
    // negligible and guarantees the user is at the top regardless
    // of browser quirks.
    var pagedMatch = location.pathname.match(/\/page\/(\d+)\/?$/);
    if (pagedMatch && parseInt(pagedMatch[1], 10) > 1) {
      try {
        if ('scrollRestoration' in history) {
          history.scrollRestoration = 'manual';
        }
      } catch (e) {}
      var resetScroll = function () {
        window.scrollTo(0, 0);
      };
      resetScroll();
      requestAnimationFrame(resetScroll);
      setTimeout(resetScroll, 100);
      setTimeout(resetScroll, 500);
      $(window).one('load', resetScroll);
    }

    // Update breadcrumbs after WCAPF AJAX filter
    // MutationObserver fallback — catches wishlist + Trustpilot
    // injections regardless of WHICH event WCAPF fires (or fails to
    // fire). The plugin uses native fetch() for AJAX rather than
    // jQuery $.ajax, AND its trigger events have changed across
    // versions (`wcapf_after_updating_products` is the current one
    // but older builds fired `wcapf-filter-updated` only). Hooking a
    // DOM observer to the products area means we don't have to rely
    // on any specific event name — the moment new product cards land,
    // we re-run the wishlist + Trustpilot init.
    //
    // Debounced 150ms so a burst of mutations (WCAPF swaps in many
    // cards at once) coalesces into a single re-init pass.
    var __acityReinitTimer = null;
    var __acityReinitInProgress = false;
    function reinitProductWidgets() {
      // Re-entrancy guard: our own mutations (span.innerHTML changes,
      // Trustpilot iframe injections) would otherwise re-trigger the
      // MutationObserver and feed back into here forever.
      __acityReinitInProgress = true;

      // Wishlist heart icon conversion.
      $('.icon_after_add_to_cart a span.wt-wishlist-button').each(function () {
        var $span = $(this);
        var expected = $span.hasClass('webtoffee_wishlist_remove')
          ? '<i class="fa-solid fa-heart"></i>'
          : '<i class="fa-regular fa-heart"></i>';
        if ($span.html() !== expected) {
          $span.html(expected);
        }
      });
      // Trustpilot widget re-scan — single source of truth at
      // `refreshTrustpilotWidgets` (top of init_woocommerce). Idempotent:
      // skips widgets that still carry our `data-tp-init` marker,
      // re-renders the ones whose marker was wiped by WCAPF's DOM swap.
      refreshTrustpilotWidgets();

      // Feefo re-scan — same deal, see refreshFeefoWidgets.
      refreshFeefoWidgets();

      // Youreko re-scan — see refreshYourekoWidgets.
      refreshYourekoWidgets();

      // Keep the page-one-only category copy in sync with the new page.
      syncPageOneCopy();

      // Trustpilot's iframe injection is async — its loadFromElement
      // schedules an iframe write some frames later. Hold the guard
      // open long enough to absorb those follow-up mutations before
      // we accept new observer ticks.
      setTimeout(function () { __acityReinitInProgress = false; }, 600);
    }
    function scheduleReinit() {
      if (__acityReinitInProgress) return;
      if (__acityReinitTimer) clearTimeout(__acityReinitTimer);
      __acityReinitTimer = setTimeout(reinitProductWidgets, 150);
    }

    // Keep the "page one only" category copy (intro + bottom description)
    // consistent with the page the customer is actually on. The server
    // omits these blocks on page 2+ so crawlers get the de-duplicated page,
    // but WCAPF only swaps the products region — the copy sits outside it
    // (`.ac-page-one-copy`) and would otherwise stay visible when paging
    // forward via AJAX (Oakley's staging sign-off, 6 Aug). Read the active
    // page from the freshly-rendered pagination and hide the copy past page
    // one. Full page loads are already correct server-side; this only
    // reconciles the AJAX path.
    function syncPageOneCopy() {
      var $copy = $('.standard-woocommerce-shop .ac-page-one-copy');
      if (!$copy.length) return;
      var $current = $('.standard-woocommerce-shop .page-numbers.current').first();
      var page = $current.length ? (parseInt($current.text().replace(/\D/g, ''), 10) || 1) : 1;
      $copy.toggle(page <= 1);
    }

    // Observe only the product-list region — `.wcapf-before-products`
    // is the wrapper WCAPF opens around the result count, ordering,
    // products UL, and pagination. The filter sidebar lives OUTSIDE
    // it, so mutations from filter-checkbox state changes / accordion
    // toggles / hover effects don't trigger our reinit.
    //
    // If the wrapper isn't on the page (e.g. WCAPF disabled, or a
    // legacy template), we skip the observer — the
    // `wcapf_after_updating_products` event handler above still
    // covers the primary path.
    var productList = document.querySelector('.wcapf-before-products');
    if (productList && typeof MutationObserver !== 'undefined') {
      var obs = new MutationObserver(function () {
        // Fire reinit on any childList mutation inside the products
        // wrapper. The 150ms debounce inside scheduleReinit coalesces
        // bursts (WCAPF's DOM swap fires many mutations in quick
        // succession) into a single re-init pass.
        scheduleReinit();

        // Pagination scroll — WCAPF (in some configs) AJAX-paginates
        // without firing any of its named events that we listen to.
        // The only reliable signal we get is that the products area
        // mutates after the click handler set paginationScrollPending.
        // When both conditions are true, scroll back to the top of
        // the shop block on the same tick.
        if (paginationScrollPending) {
          paginationScrollPending = false;
          var $shopAfterAjax = $('.standard-woocommerce-shop');
          if ($shopAfterAjax.length) {
            var headerOffsetAjax = $('header').outerHeight() || 0;
            var targetAjax = $shopAfterAjax.offset().top - headerOffsetAjax - 16;
            $('html, body').stop().animate({ scrollTop: targetAjax }, 400);
          }
        }
      });
      obs.observe(productList, { childList: true, subtree: true });
    }

    $(document).on('wcapf_after_updating_products', function(e, $response) {
      var $newBreadcrumbs = $response.find('.breadcrumbs');
      if ($newBreadcrumbs.length) {
        $('.breadcrumbs').html($newBreadcrumbs.html());
      }

      // Hide/show the page-one-only category copy to match the new page.
      syncPageOneCopy();

      // Re-run moveFilterForm after the AJAX merge. WCAPF's response can
      // re-render the wcapf-form / active-filters chip row back into their
      // original server-side slots (`.desktop-filters` and `.site-main`),
      // detaching them from `.mobile-filters` where we initially moved
      // them. Without this re-move, tapping the mobile Filter button
      // reveals an empty drawer that just pushed the products down ~20px
      // — Liam's repro on `/cooking/range-cookers/dual-fuel-range-cookers/`
      // after applying any single filter on mobile.
      //
      // `moveFilterForm` short-circuits on the `lastFilterLayout` guard
      // so we reset that first to force the move even when the layout
      // hasn't changed (we're still on mobile, same as before AJAX).
      lastFilterLayout = null;
      moveFilterForm();

      // #4 — the drawer no longer auto-closes when a filter changes; the
      // customer stacks selections and taps "Apply filters" to close. Make
      // sure the Apply button + sub-filter toggles are re-injected after
      // the AJAX re-render (the form markup can be replaced).
      ensureMobileFilterApply();
      injectSubfilterToggles();

      // Re-init the wishlist heart icons + Trustpilot widgets on the
      // freshly-injected products. WCAPF uses native fetch() rather
      // than jQuery $.ajax, so `$(document).ajaxComplete` never fires
      // for its AJAX updates — meaning the older handler down at the
      // bottom of this file (which calls updateWishlistIcons /
      // loadFromElement on ajaxComplete) was always a no-op for the
      // filter/pagination flow. Both pieces have to run from
      // wcapf_after_updating_products instead.
      //
      // The 150ms delay gives WCAPF's DOM-swap a chance to settle
      // (the response HTML is merged into the page asynchronously
      // inside the plugin's update routine).
      setTimeout(function () {
        // Wishlist span → FA heart icon. Mirrors updateWishlistIcons()
        // defined further down in this file (we can't call it directly
        // here because it's locally scoped to the init function, but
        // the logic is one expression).
        $('.icon_after_add_to_cart a span.wt-wishlist-button').each(function () {
          var $span = $(this);
          var expected = $span.hasClass('webtoffee_wishlist_remove')
            ? '<i class="fa-solid fa-heart"></i>'
            : '<i class="fa-regular fa-heart"></i>';
          if ($span.html() !== expected) {
            $span.html(expected);
          }
        });

        // Trustpilot widgets — single source of truth at
        // `refreshTrustpilotWidgets`. The dedup marker means freshly-
        // injected widgets (whose markers were wiped by WCAPF's DOM
        // swap) render once; already-mounted ones get skipped.
        refreshTrustpilotWidgets();

        // Feefo stars — same deal, see refreshFeefoWidgets.
        refreshFeefoWidgets();
      }, 150);

      // Scroll back to the top of the shop block when the AJAX update was
      // triggered by clicking a pagination link. Belt-and-braces fallback —
      // the MutationObserver above usually clears `paginationScrollPending`
      // first, but if WCAPF fires this event before the DOM swap (or on a
      // build where the observer doesn't catch it) this handler still
      // anchors the user back to the top.
      if (paginationScrollPending) {
        paginationScrollPending = false;
        var $shop = $('.standard-woocommerce-shop');
        if ($shop.length) {
          var headerOffset = $('header').outerHeight() || 0;
          var target = $shop.offset().top - headerOffset - 16;
          $('html, body').animate({ scrollTop: target }, 400);
        }
      }

      // WCAPF re-runs its slider init after some filter responses, which
      // rebinds the per-keystroke `input` listeners. Re-apply the commit-on-
      // blur override so the price filter keeps waiting for the user to
      // finish typing rather than firing mid-word.
      setTimeout(debouncePriceFilterInputs, 0);

      // WCAPF replaces filter DOM on every response. Re-add `.d-none` to
      // any filter whose content is just "N/A" so they stay hidden — the
      // ajaxComplete handler also covers this with a 100ms delay, but
      // running it here too closes the visible gap between WCAPF's DOM
      // swap and that timer.
      hideEmptyWcapfFilters();
    });

    // Cart toggle
    $('.cart-toggle').on('click', function(){
      $('#cart-tray').toggleClass('active');
    });

    function setCartTrayPosition() {
      var headerHeight = $('header').outerHeight();
      
      $('#cart-tray').css({
        'height': 'calc(100% - ' + headerHeight + 'px)',
        'top': headerHeight + 'px'
      });
    }

    $('.qty').each(function() {
      var $qty = $(this);

      $qty.wrap('<div class="quantity-controls d-flex align-items-center"></div>');
      $qty.before('<button type="button" class="qty-btn qty-minus"><i class="fa-solid fa-dash"></i></button>');
      $qty.after('<button type="button" class="qty-btn qty-plus"><i class="fa-solid fa-plus"></i></button>');
    });

    // Plus button functionality
    $(document).on('click', '.qty-plus', function() {
      var qtyInput = $(this).siblings('.qty');
      var currentVal = parseInt(qtyInput.val()) || 1;
      var maxVal = parseInt(qtyInput.attr('max')) || 999;
      
      if (currentVal < maxVal) {
        qtyInput.val(currentVal + 1).trigger('change');
      }
    });
    
    // Minus button functionality
    $(document).on('click', '.qty-minus', function() {
      var qtyInput = $(this).siblings('.qty');
      var currentVal = parseInt(qtyInput.val()) || 1;
      // Inside the basket form, allow stepping to 0 — this triggers a
      // "remove this line" via the change handler below, which prompts
      // for confirmation before firing the AJAX call. Everywhere else
      // (e.g. PDP qty selector, multibuy card) keeps the standard
      // `min` floor (defaults to 1).
      var inCart = qtyInput.closest('.woocommerce-cart-form').length > 0;
      var minVal = inCart ? 0 : (parseInt(qtyInput.attr('min')) || 1);

      if (currentVal > minVal) {
        // Stash the pre-decrement value so the change handler can
        // restore it if the customer cancels the remove confirmation
        // (the input never fires focus when only the button is
        // clicked, so the focus-bound `prev-qty` data isn't set).
        qtyInput.data('prev-qty', currentVal);
        qtyInput.val(currentVal - 1).trigger('change');
      }
    });

    // Add to cart button product card
    $(document).on('click', '.add-to-cart-btn', function(e) {
      e.preventDefault();
      
      var button = $(this);
      var productId = button.data('product-id');

      let quantity = 1;
      if(button.data('quantity')) {
        quantity = button.data('quantity');
      }
      
      // Disable button and show loading state
      button.prop('disabled', true);
      let span = $(button).find('span');

      if(span.length > 0) {
        span.text('Adding ...');
      }
      else {
        button.text('Adding...');
      }

      $.ajax({
        type: 'POST',
        url: wc_add_to_cart_params.ajax_url,
        data: {
          action: 'woocommerce_add_to_cart',
          product_id: productId,
          quantity: quantity
        },
        success: function(response) {
          if (response.error) {
            alert('Error: ' + response.data);

            button.prop('disabled', false);
            if(span.length > 0) {
              span.text('Add to cart');
            }
            else {
              span.text('Add to cart');
            }
          } else {
            // Success - apply cart fragments inline. wc-cart-fragments.js
            // (the WC core script that normally listens for added_to_cart
            // and swaps DOM nodes by selector) isn't always present on the
            // pages our product cards render on, so doing the replacement
            // ourselves is more reliable than relying on that handler.
            // We still trigger added_to_cart so any other listeners
            // (off-canvas cart, mini-cart counts, etc.) get a chance.
            if (response.fragments) {
              $.each(response.fragments, function(selector, html) {
                $(selector).replaceWith(html);
              });
              try {
                sessionStorage.setItem(
                  wc_cart_fragments_params && wc_cart_fragments_params.fragment_name ? wc_cart_fragments_params.fragment_name : 'wc_fragments_' + (response.cart_hash || ''),
                  JSON.stringify(response.fragments)
                );
              } catch (err) { /* sessionStorage unavailable — non-fatal */ }
            }
            $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, button]);

            // Show notice for out-of-stock products
            var stockStatus = button.data('stock-status');
            if (stockStatus === 'outofstock' || stockStatus === 'onbackorder') {
              var noticeHtml = '<div class="woocommerce-info oos-added-notice" style="margin-bottom: 1rem; padding: 1rem; background: #f0f4ff; border-left: 4px solid #400fc4; border-radius: 4px;">' +
                '<p style="margin: 0; font-size: 0.875rem;">This product is currently awaiting stock. Delivery date will be confirmed once available.</p>' +
                '</div>';
              // Remove any existing OOS notice first
              $('.oos-added-notice').remove();
              // Insert notice at the top of the product listing
              var $noticeTarget = $('.woocommerce-notices-wrapper').first();
              if ($noticeTarget.length) {
                $noticeTarget.html(noticeHtml);
              } else {
                button.closest('.row').before(noticeHtml);
              }
              // Auto-remove after 6 seconds
              setTimeout(function() { $('.oos-added-notice').fadeOut(400, function() { $(this).remove(); }); }, 6000);
            }

            if(span.length > 0) {
              // Optional: Show success message
              span.text('Added!');
              setTimeout(function() {
                button.prop('disabled', false);
                span.text('Add to Basket');
              }, 2000);
            }
            else {
              // Optional: Show success message
              button.text('Added!');
              setTimeout(function() {
                button.prop('disabled', false);
                button.text('Add to Basket');
              }, 2000);
            }
          }
        },
        error: function() {
          alert('Something went wrong. Please try again.');
          button.prop('disabled', false);

          if(span.length > 0) {
            span.text('Add to cart');
          }
          else {
            button.text('Add to cart');
          }
        }
      });
    });

    // Reset Variation Toggle
    $(document).on('change', '.variations select', function() {
      setTimeout(function(){
        if ($('.reset_variations').css('visibility') !== 'hidden') {
          $('.reset_variations').addClass('active');
        } else {
          $('.reset_variations').removeClass('active');
        }
      }, 500);
    });

    // Cart page AJAX quantity update
    var cartUpdateTimer;
    $(document).on('change', '.woocommerce-cart-form input.qty', function() {
      var $quantityInput = $(this);
      var cart_item_key = $quantityInput.attr('name').match(/cart\[(.*?)\]/);
      if (!cart_item_key) return;
      cart_item_key = cart_item_key[1];
      var quantity = parseInt($quantityInput.val()) || 0;
      var $cartItem = $quantityInput.closest('.col-12.mb-6');

      // Going to 0 means "remove this line". Confirm with the customer
      // before firing the AJAX so an accidental triple-tap on the minus
      // button (or a stray keystroke) doesn't silently empty their
      // basket. Triggers for both the minus-button path and typing 0
      // directly. On cancel, revert to the previous quantity and bail.
      if (quantity === 0) {
        var prevQty = parseInt($quantityInput.data('prev-qty'), 10);
        if (isNaN(prevQty) || prevQty < 1) prevQty = 1;
        var confirmMsg = 'Are you sure you want to remove this item from your basket?';
        if (typeof window.confirm === 'function' && !window.confirm(confirmMsg)) {
          $quantityInput.val(prevQty);
          return;
        }
      }

      $cartItem.css('opacity', '0.5');

      clearTimeout(cartUpdateTimer);
      cartUpdateTimer = setTimeout(function() {
        $.ajax({
          type: 'POST',
          url: ajax_object.ajax_url,
          data: {
            action: 'update_cart_item_quantity',
            cart_item_key: cart_item_key,
            quantity: quantity,
            security: ajax_object.update_cart_nonce
          },
          success: function(response) {
            if (response.success) {
              $(document.body).trigger('wc_fragment_refresh');

              // FBT deal savings are cart-wide: changing ONE line's quantity
              // can change ANOTHER line's badge / "Free" price (fewer
              // fridges = fewer free filters). Those badges are
              // server-rendered, so when a deal pill is on show re-render
              // the whole basket, same as the empty-cart path below.
              if ($('.woocommerce-cart-form .product-pill-box').length) {
                location.reload();
                return;
              }

              if (quantity === 0) {
                $cartItem.fadeOut(300, function() { $(this).remove(); });
              }

              // Update price display for this item
              if (response.data.item_subtotal) {
                $cartItem.find('.text-secondary.fw-bold').first().html(response.data.item_subtotal);
              }

              // Refresh cart totals section
              if (response.data.cart_totals_html) {
                $('.cart_totals').replaceWith(response.data.cart_totals_html);
              }

              // Reload if cart is empty
              if (response.data.cart_contents_count === 0) {
                location.reload();
              }
            } else {
              $quantityInput.val($quantityInput.data('prev-qty') || 1);
            }
          },
          error: function() {
            $quantityInput.val($quantityInput.data('prev-qty') || 1);
          },
          complete: function() {
            $cartItem.css('opacity', '1');
          }
        });
      }, 300);
    });

    $(document).on('focus', '.woocommerce-cart-form input.qty', function() {
      $(this).data('prev-qty', $(this).val());
    });

    // Handle restore/undo item - capture phase to beat WooCommerce's handler
    document.addEventListener('click', function(e) {
      var link = e.target.closest('.restore-item');
      if (link) {
        e.preventDefault();
        e.stopImmediatePropagation();
        window.location.href = link.getAttribute('href');
      }
    }, true);

    // "Will it fit?" / dimensions modal — Dismiss cancels the add-to-basket.
    // The product was already added on form submit; if the user dismisses,
    // remove that line from the cart so they're not silently charged for
    // something they're unsure about.
    var willItFitConfirmed = false;

    $(document).on('click', '#dimensionsModal .will-it-fit-confirm', function() {
      willItFitConfirmed = true;
    });

    $('#dimensionsModal').on('hidden.bs.modal', function() {
      var $modal = $(this);

      if (willItFitConfirmed) {
        // Reset for any future opens and bail — keep the item in the cart.
        willItFitConfirmed = false;
        return;
      }

      var cartItemKey = $modal.data('cartItemKey');
      var removeNonce = $modal.data('removeNonce');

      if (!cartItemKey || !removeNonce || typeof ajax_object === 'undefined') {
        return;
      }

      $.ajax({
        type: 'POST',
        url: ajax_object.ajax_url,
        data: {
          action: 'update_cart_item_quantity',
          cart_item_key: cartItemKey,
          quantity: 0,
          security: removeNonce
        },
        success: function() {
          $(document.body).trigger('wc_fragment_refresh');
        }
      });

      // Clear so a second close can't double-remove.
      $modal.data('cartItemKey', null);
    });

$(document).on('change', '.multibuy-product-card input.qty', function() {
      let quantity = $(this).val();
      let $card = $(this).closest('.multibuy-product-card');
      let $cartBtn = $card.find('button.add-to-cart-btn');
      $cartBtn.attr('data-quantity', quantity);
    });

    // WCAPF JS
    function shortDescriptionToggle() {
      var $content = $('.short-description-content');
      var $toggle = $('.short-description-toggle');

      if (!$content.length) return;

      // Check if content is actually clamped (overflowing)
      var el = $content[0];
      if (el.scrollHeight > el.clientHeight) {
        $toggle.show();
      }

      $toggle.on('click', function() {
        $content.toggleClass('expanded');
        $(this).text($content.hasClass('expanded') ? 'Read Less' : 'Read More');
      });
    }

    var lastFilterLayout = null;
    function moveFilterForm() {
      var isMobile = $(window).width() < 992;
      var layout = isMobile ? 'mobile' : 'desktop';

      // Only move DOM elements when the layout actually changes
      if (layout === lastFilterLayout) return;
      lastFilterLayout = layout;

      if (isMobile) {
        $('.wcapf-form').first().appendTo('.mobile-filters:first');
        $('.wcapf-active-filters-before-shop-loop').first().prependTo('.mobile-filters:first');

        // Move .results-container to position 4 (index 3) within the mobile section
        const mobileSection = $('.d-lg-none .wcapf-before-products').first();
        const mobileResults = mobileSection.find('.results-container');
        const fourthPosition = mobileSection.children().eq(3);

        if (fourthPosition.length && !mobileResults.is(fourthPosition)) {
          mobileResults.insertBefore(fourthPosition);
        }

        // #4 / #2 — ensure the Apply button + sub-filter toggles exist once
        // the form is in the mobile drawer.
        ensureMobileFilterApply();
        injectSubfilterToggles();
      } else {
        // Hide mobile filters when switching to desktop
        $('.mobile-filters').hide();

        $('.wcapf-form').first().appendTo('.desktop-filters');
        $('.wcapf-active-filters-before-shop-loop').first().prependTo('.site-main');

        // Move .results-container to position 2 (index 1) within the desktop section
        const desktopSection = $('.d-none.d-lg-block .wcapf-before-products').first();
        const desktopResults = desktopSection.find('.results-container');
        const secondPosition = desktopSection.children().eq(1);

        if (secondPosition.length && !desktopResults.is(secondPosition)) {
          desktopResults.insertBefore(secondPosition);
        }
      }
    }

    function stickyFilterHeight() {
      var $shop = $('.standard-woocommerce-shop');
      if (!$shop.length) return;

      var $form = $shop.find('.wcapf-form');
      if (!$form.length) return;

      if ($(window).width() >= 992) {
        var headerHeight = $('header').outerHeight() || 0;
        var $spacingDiv = $shop.children().first();
        var paddingTop = parseInt($spacingDiv.css('padding-top')) || 0;
        var calcHeight = 'calc(100vh - ' + (headerHeight + paddingTop + 128) + 'px)';

        $form.css({ 'max-height': calcHeight, 'overflow-y': 'auto' });
      } else {
        $form.css({ 'max-height': '', 'overflow-y': '' });
      }
    }

    // Delegated so the handler survives WCAPF AJAX replacing the
    // `loop/orderby.php` markup. Direct `$('.filter-toggle').on()`
    // binds to the original DOM node only; after one filter is
    // applied the form is re-rendered and the new button has no
    // listener — second tap does nothing.
    $(document).on('click', '.filter-toggle', function(){
      $('.mobile-filters').toggle();
    });

    function closeMobileFilters() {
      if ($(window).width() < 992) {
        $('.mobile-filters').hide();
      }
    }

    // #4 — mobile "Apply filters" button. Filters still apply live on each
    // change; the button simply closes the drawer so the customer can stack
    // several selections, then tap once to see the results. (Previously the
    // drawer auto-closed on every change, which made multi-select fiddly.)
    // Always kept as the LAST child of the drawer. moveFilterForm()
    // re-appends the wcapf-form to .mobile-filters on every AJAX update,
    // which would land below an already-present button and shove it to the
    // top — so rather than no-op when the button exists, we re-append it
    // (jQuery moves the existing node) to force it back to the bottom.
    function ensureMobileFilterApply() {
      var $drawer = $('.mobile-filters').first();
      if (!$drawer.length) return;
      var $btn = $drawer.find('.filter-apply');
      if (!$btn.length) {
        $btn = $(
          '<button type="button" class="filter-apply btn-gradient w-100 mt-4 mb-4 d-flex align-items-center justify-content-center gap-2">' +
            '<span>Apply filters</span><i class="fa-solid fa-check"></i>' +
          '</button>'
        );
      }
      $drawer.append($btn); // create-or-move to the end
    }
    $(document).on('click', '.filter-apply', function () {
      $('.mobile-filters').hide();
      // Bring the freshly-filtered results into view.
      if (window.scrollTo) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
    });

    // #2 — collapse WCAPF nested sub-filters (child terms) behind a per-parent
    // toggle. Any `li.wcapf-filter-option` that contains a child
    // `ul.wcapf-filter-options` gets a chevron toggle injected; the nested
    // list starts collapsed unless it contains a checked input (keep an
    // active branch open). Re-run after WCAPF AJAX re-render. Idempotent via
    // the `data-ac-subfilter` flag on the parent.
    function injectSubfilterToggles() {
      $('li.wcapf-filter-option').each(function () {
        var $li = $(this);
        var $childList = $li.children('ul.wcapf-filter-options').first();
        if (!$childList.length || $li.attr('data-ac-subfilter') === '1') return;
        $li.attr('data-ac-subfilter', '1');

        var hasChecked = $childList.find('input:checked').length > 0;
        if (!hasChecked) $childList.addClass('ac-subfilter-collapsed');

        var $toggle = $('<button type="button" class="ac-subfilter-toggle" aria-expanded="' + (hasChecked ? 'true' : 'false') + '">' +
          '<i class="fa-solid fa-chevron-down" aria-hidden="true"></i><span class="visually-hidden">Toggle sub-categories</span></button>');
        // Sit the toggle next to the parent's own label/checkbox.
        $li.children('ul.wcapf-filter-options').first().before($toggle);
      });
    }
    $(document).on('click', '.ac-subfilter-toggle', function () {
      var $btn = $(this);
      var $list = $btn.siblings('ul.wcapf-filter-options').first();
      var collapsed = $list.toggleClass('ac-subfilter-collapsed').hasClass('ac-subfilter-collapsed');
      $btn.attr('aria-expanded', collapsed ? 'false' : 'true');
    });

    // Stock Check Toggle
    function initStockStatusToggle() {
      // Check if the stock status filter exists
      if (!$('.wcapf-filter-meta-_stock_status').length) {
        return; // Exit if the element doesn't exist
      }

      var $filterTitle = $('.wcapf-filter-meta-_stock_status .wcapf-filter-title');
      var $titleInner = $filterTitle.find('.wcapf-filter-title-inner');
      
      if ($filterTitle.length && $titleInner.length) {
          // Store the original text
          var originalText = $titleInner.text();
          
          // Replace the entire content
          $filterTitle.html(`
            <div class="toggle-switch">
              <input type="checkbox" id="hide-out-of-stock" class="toggle-input">
              <label for="hide-out-of-stock" class="toggle-label">
                <span class="toggle-slider"></span>
              </label>
              <span class="wcapf-filter-title-inner toggle-text">${originalText}</span>
            </div>
          `);

          // Check URL for __stock_status=instock parameter
          var urlParams = new URLSearchParams(window.location.search);
          var stockStatus = urlParams.get('__stock_status');
          
          if (stockStatus === 'instock') {
            $('#hide-out-of-stock').prop('checked', true);
          }

          // Add the toggle functionality
          $('#hide-out-of-stock').change(function() {
            if ($(this).is(':checked')) {
              // Find the instock item and check its checkbox
              $('.wcapf-filter-meta-_stock_status .wcapf-list-wrapper .wcapf-filter-item .wcapf-nav-item-text')
                .filter(function() {
                  return $(this).text().trim().toLowerCase() === 'instock';
                })
                .closest('.wcapf-filter-item')
                .find('input[type="checkbox"]')
                .prop('checked', true)
                .trigger('change'); // Trigger change event to activate filtering
            } else {
              // Uncheck the instock checkbox when toggle is off
              $('.wcapf-filter-meta-_stock_status .wcapf-list-wrapper .wcapf-filter-item .wcapf-nav-item-text')
                .filter(function() {
                  return $(this).text().trim().toLowerCase() === 'instock';
                })
                .closest('.wcapf-filter-item')
                .find('input[type="checkbox"]')
                .prop('checked', false)
                .trigger('change');
            }
          });
        }
    }

    // Limit Filter Output
    var lastFilterVisibleCount = null;

    // How many filters have to spill past the cap before the "Show more
    // filters" toggle earns its place. Below this we just render them all.
    // Mobile only — desktop has no cap at all, see below.
    var FILTER_TOGGLE_MIN_OVERFLOW = 4;

    function limitFiltersWithToggle() {
      // Only target the first .wcapf-form (the one moved between mobile/desktop containers)
      var $form = $('.wcapf-form').first();

      if (!$form.length) {
        return; // Exit if form doesn't exist
      }

      // No cap on desktop. James at the QBR (17 Aug 2026): "I don't like the
      // fact that you have to expand the filters either… sometimes see show
      // more filters, and it shows like one more. You might as well put them
      // all there in the first place."
      //
      // A cap only pays for itself where the list pushes something else off
      // the screen. It does not on desktop: .wcapf-form already carries its
      // own max-height and overflow-y from stickyFilterHeight(), so a long
      // facet list scrolls inside the sidebar and never displaces the product
      // grid. Capping there bought nothing and cost a click.
      //
      // The mobile drawer is different — it expands in the flow and shoves
      // the products down the page, so six plus a toggle still earns its
      // place there.
      var visibleCount = $(window).width() < 992 ? 6 : Infinity;

      // Only rebuild when the visible count actually changes
      if (visibleCount === lastFilterVisibleCount) return;
      lastFilterVisibleCount = visibleCount;

      // Clean up existing state BEFORE measuring. Clear our own inline
      // display rather than calling .show(): .show() writes `display: block`,
      // which would mask the very stylesheet rules we are about to read.
      var $all = $form.find('.wcapf-filter');
      $all.removeClass('wcapf-hidden-filter').css('display', '');
      $form.find('.wcapf-show-more-wrapper').remove();
      $form.off('click', '.wcapf-show-more-btn'); // Remove existing event handlers

      // Desktop: the reset above is the whole job.
      if (visibleCount === Infinity) return;

      // Count only the facets that actually put something on the page.
      //
      // This used to be `.not('.wcapf-field-hidden')`, which caught WCAPF's
      // own "no values left in this context" hide but nothing else. Several
      // facets are hidden by the THEME and still got counted: the keyword
      // filter (hidden outright, it exists only to feed the search-to-keyword
      // bridge) and the Width / Height facets on accessory archives. On
      // /washing-machines/ that produced 14 counted against a cap of 12, so
      // two were pushed behind "Show more filters" — and one of the two was
      // the keyword facet, which renders nothing. The toggle existed to
      // reveal a single real filter.
      //
      // Reading computed display instead catches every hide, whoever set it,
      // including `display: none !important`. Safe inside the closed mobile
      // drawer too: display is not inherited, so a child of a hidden parent
      // still reports its own computed value.
      var $filters = $all.filter(function () {
        return window.getComputedStyle(this).display !== 'none';
      });

      // Not enough surplus to be worth a toggle — show the lot.
      if ($filters.length - visibleCount < FILTER_TOGGLE_MIN_OVERFLOW) {
        return;
      }

      if ($filters.length > visibleCount) {
        // Hide filters beyond the limit
        $filters.slice(visibleCount).addClass('wcapf-hidden-filter').hide();

        // Create toggle button
        var toggleButton = `
          <div class="wcapf-show-more-wrapper">
            <button type="button" class="wcapf-show-more-btn btn-underline-tertiary-alt">
              <span class="show-text">Show more filters</span>
              <span class="hide-text" style="display: none;">Show fewer filters</span>
            </button>
          </div>
        `;

        // Append button to form
        $form.append(toggleButton);

        // Add click functionality
        $form.on('click', '.wcapf-show-more-btn', function(e) {
          e.preventDefault();

          var $btn = $(this);
          var $showText = $btn.find('.show-text');
          var $hideText = $btn.find('.hide-text');
          var $hiddenFilters = $form.find('.wcapf-hidden-filter');

          if ($hiddenFilters.is(':visible')) {
            // Hide extra filters
            $hiddenFilters.slideUp();
            $showText.show();
            $hideText.hide();
            $btn.removeClass('expanded');
          } else {
            // Show extra filters
            $hiddenFilters.slideDown();
            $showText.hide();
            $hideText.show();
            $btn.addClass('expanded');
          }
        });
      }
    }

    function addProductPerPageField() {
      $('.wcapf-form').each(function() {
        var $form = $(this);
        
        // Check if the field doesn't already exist to avoid duplicates
        if (!$form.find('input[name="product-per-page"]').length) {
          $form.append('<input type="hidden" name="product-per-page" id="product-per-page" value="12">');
        }
      });
    }

    function updateInstockText() {
      $('.wcapf-active-filter-item .wcapf-nav-item-text').each(function() {
        var $this = $(this);
        if ($this.text().trim().toLowerCase() === 'instock') {
          $this.text('In Stock');
        }
      });
    }

    // Hide WCAPF filters that contain N/A
    function hideEmptyWcapfFilters() {
      $('.wcapf-filter').each(function() {
        var $filter = $(this);
        var hasNA = false;

        // Check if any child div contains exactly "N/A" text
        $filter.find('div').each(function() {
          if ($(this).text().trim() === 'N/A') {
            hasNA = true;
            return false; // Break the loop
          }
        });

        if (hasNA) {
          $filter.addClass('d-none');
        } else {
          $filter.removeClass('d-none');
        }
      });
    }

    /**
     * Replace WCAPF's per-keystroke price filter listener with one that
     * commits in two ways:
     *   1. Immediately when the input is blurred (via `change`) or Enter
     *      is pressed.
     *   2. 1s after the user stops typing (debounced `input`).
     *
     * The shop on this site uses WCAPF's spinbox (number input) variant of
     * the price filter, NOT the noUiSlider variant. The relevant plugin
     * function is `handleNumberInputFilters` (wc-ajax-product-filter-scripts.js
     * line 652-735). It binds via delegated jQuery event:
     *
     *   $body.on('input', '.wcapf-range-number .min-value, ...', fn)
     *
     * with a 300 ms `setTimeout` debounce — too short, so any mid-typing
     * pause triggers a clamp + overwrite of the input value (the "value
     * resets while I'm still typing" complaint).
     *
     * Because WCAPF uses delegated binding on `body`, removing the listener
     * also has to be delegated: `.off('input', selector)` on the same `body`
     * element, not on the input itself.
     *
     * This function:
     *   1. Removes WCAPF's delegated `input` handler.
     *   2. Removes any previous bind from this override (namespaced) so it's
     *      idempotent and safe to re-call after AJAX filter refreshes.
     *   3. Binds a delegated `input` handler with a 1000 ms debounce — fires
     *      after the user stops typing without needing to blur.
     *   4. Binds a delegated `change` handler that fires immediately on blur
     *      (and clears any pending debounce timer to avoid double-firing).
     *   5. Binds a delegated `keydown` handler so Enter triggers blur and
     *      submits the value immediately.
     */
    function debouncePriceFilterInputs() {
      if (typeof window.WCAPF === 'undefined' || typeof window.WCAPF.requestFilter !== 'function') {
        // WCAPF script may load after the theme bundle on slow connections;
        // retry shortly so the override actually attaches. Without this we
        // silently fall through to the vanilla plugin's per-keystroke
        // (~0ms) AJAX, which is what the price-range UX bug looks like.
        if (debouncePriceFilterInputs._retries === undefined) {
          debouncePriceFilterInputs._retries = 0;
        }
        if (debouncePriceFilterInputs._retries < 10) {
          debouncePriceFilterInputs._retries++;
          setTimeout(debouncePriceFilterInputs, 500);
        }
        return;
      }
      debouncePriceFilterInputs._retries = 0;

      var rangeNumberSelectors = '.wcapf-range-number .min-value, .wcapf-range-number .max-value';
      var $body = $('body');
      var TYPING_DELAY = 2000; // ms after the last keystroke before auto-commit

      // Drop WCAPF's per-keystroke delegated listener.
      $body.off('input', rangeNumberSelectors);

      // Drop any previous bind from this override so re-calling is safe.
      $body.off('input.acityPriceFilter change.acityPriceFilter keydown.acityPriceFilter', rangeNumberSelectors);

      // Track the last min/max we sent to WCAPF, so subsequent commits with
      // the same values are skipped — even if the wrapper's data attributes
      // haven't been updated by the AJAX response yet. This is what avoids
      // a duplicate request when the user blurs during an in-flight AJAX
      // response, since the wrapper still shows the previous data-min-value
      // until the response settles.
      var lastCommittedMin = null;
      var lastCommittedMax = null;

      // Shared commit logic — used by the typing debounce, blur, and Enter
      // paths. Reads min and max from the wrapper, clamps into range, writes
      // back, and fires WCAPF.requestFilter via the URL template.
      function commitRangeNumber($rangeNumber) {
        if (!$rangeNumber || !$rangeNumber.length) return;

        var rangeMinValue = parseFloat($rangeNumber.attr('data-range-min-value'));
        var rangeMaxValue = parseFloat($rangeNumber.attr('data-range-max-value'));
        var oldMinValue = parseFloat($rangeNumber.attr('data-min-value'));
        var oldMaxValue = parseFloat($rangeNumber.attr('data-max-value'));

        var $minInput = $rangeNumber.find('.min-value');
        var $maxInput = $rangeNumber.find('.max-value');

        var minValue = parseFloat($minInput.val());
        var maxValue = parseFloat($maxInput.val());
        if (isNaN(minValue)) minValue = rangeMinValue;
        if (isNaN(maxValue)) maxValue = rangeMaxValue;

        // Clamp into the allowed range, then make sure min <= max.
        minValue = Math.max(rangeMinValue, Math.min(rangeMaxValue, minValue));
        maxValue = Math.max(rangeMinValue, Math.min(rangeMaxValue, maxValue));
        if (minValue > maxValue) {
          var tmp = minValue;
          minValue = maxValue;
          maxValue = tmp;
        }

        // Reflect the clamped values back into the inputs.
        $minInput.val(minValue);
        $maxInput.val(maxValue);

        // Skip if these are the same values we last sent — handles the
        // common race where a blur fires while the AJAX from a previous
        // commit is still in flight.
        if (minValue === lastCommittedMin && maxValue === lastCommittedMax) {
          return;
        }

        // Skip if nothing actually changed compared to the applied filter
        // state on the wrapper.
        if (minValue === oldMinValue && maxValue === oldMaxValue) {
          return;
        }

        lastCommittedMin = minValue;
        lastCommittedMax = maxValue;

        if (minValue === rangeMinValue && maxValue === rangeMaxValue) {
          window.WCAPF.requestFilter($rangeNumber.data('clear-filter-url'));
        } else {
          var url = $rangeNumber.data('url').replace('%1s', minValue).replace('%2s', maxValue);
          window.WCAPF.requestFilter(url);
        }
      }

      function clearPendingTimer($rangeNumber) {
        var timer = $rangeNumber.data('acityPriceTimer');
        if (timer) {
          clearTimeout(timer);
          $rangeNumber.removeData('acityPriceTimer');
        }
      }

      // Capture-phase native listeners — bound ONCE on document so they
      // survive WCAPF's `.html()` re-renders of the filter markup, and run
      // BEFORE any jQuery delegated handler (the plugin's per-keystroke
      // listener bubbles, so it never sees an event we stop here).
      //
      // Behaviour while a range input is focused:
      //   - input  → stopImmediatePropagation (plugin's keystroke listener
      //              never fires); reset our 2-second pause timer.
      //   - change → stopImmediatePropagation; commit immediately
      //              (browsers fire `change` on blur for number inputs).
      //   - blur   → commit immediately (covers cases where `change` is
      //              swallowed by re-render).
      //   - 2s pause → commit once. If the user resumes typing, freeze
      //              cycle restarts.
      //   - Enter  → blur the input.
      if (!debouncePriceFilterInputs._captureBound) {
        debouncePriceFilterInputs._captureBound = true;

        var matchesFn = (function () {
          var p = Element.prototype;
          return p.matches || p.msMatchesSelector || p.webkitMatchesSelector;
        })();

        function isRangeInput(el) {
          if (!el || el.nodeType !== 1 || !matchesFn) return false;
          return matchesFn.call(el, '.wcapf-range-number .min-value, .wcapf-range-number .max-value');
        }

        function getRangeWrapper(el) {
          var p = el;
          while (p && p !== document) {
            if (p.classList && p.classList.contains('wcapf-range-number')) return $(p);
            p = p.parentNode;
          }
          return null;
        }

        function scheduleCommit(el) {
          var $wrap = getRangeWrapper(el);
          if (!$wrap || !$wrap.length) return;
          clearPendingTimer($wrap);
          var timer = setTimeout(function () {
            $wrap.removeData('acityPriceTimer');
            // Re-check the input is still attached — WCAPF may have
            // re-rendered the filter while the timer was pending.
            if (!document.contains(el)) return;
            commitRangeNumber($wrap);
          }, TYPING_DELAY);
          $wrap.data('acityPriceTimer', timer);
        }

        function commitNow(el) {
          var $wrap = getRangeWrapper(el);
          if (!$wrap || !$wrap.length) return;
          clearPendingTimer($wrap);
          if (!document.contains(el)) return;
          commitRangeNumber($wrap);
        }

        document.addEventListener('input', function (e) {
          if (!isRangeInput(e.target)) return;
          // While the user is interacting with the field, stop ALL other
          // listeners (notably WCAPF's own per-keystroke handler) from
          // reacting. Our 2s timer is the single source of truth.
          e.stopImmediatePropagation();
          scheduleCommit(e.target);
        }, true);

        document.addEventListener('change', function (e) {
          if (!isRangeInput(e.target)) return;
          e.stopImmediatePropagation();
          commitNow(e.target);
        }, true);

        // Belt-and-braces: some browsers don't fire `change` reliably
        // when value programmatically changes before blur. Hook blur too.
        document.addEventListener('blur', function (e) {
          if (!isRangeInput(e.target)) return;
          commitNow(e.target);
        }, true);

        document.addEventListener('keydown', function (e) {
          if (!isRangeInput(e.target)) return;
          if (e.key === 'Enter' || e.keyCode === 13) {
            e.preventDefault();
            e.stopImmediatePropagation();
            if (typeof e.target.blur === 'function') e.target.blur();
          }
        }, true);
      }
    }

    // Cart / Checkout Styles
    function checkoutStyles() {
      setTimeout(function(){
        // Check if trash icon hasn't been added yet
        if ($('.wc-block-cart-item__remove-link i.fa-trash').length === 0) {
          $('.wc-block-cart-item__remove-link').html('<i class="fa-solid fa-trash"></i>');
        }
        
        // Check if cart items aren't already wrapped
        if ($('.wc-block-cart-items').parent('.bg-grey.p-4.p-md-6.rounded-3').length === 0) {
          $('.wc-block-cart-items').wrapAll('<div class="bg-grey p-4 p-md-6 rounded-3"></div>');
        }
        
        // Check if sidebar isn't already wrapped
        if ($('.wc-block-components-sidebar > .bg-grey.p-4.p-md-6.rounded-3').length === 0) {
          $('.wc-block-components-sidebar').wrapInner('<div class="bg-grey p-4 p-md-6 rounded-3"></div>');
        }

        // Check if order summary isn't already wrapped
        if ($('.wc-block-components-main .wp-block-woocommerce-checkout-order-summary-block > .bg-grey.p-4.p-md-6.rounded-3').length === 0) {
          $('.wc-block-components-main .wp-block-woocommerce-checkout-order-summary-block').wrapInner('<div class="bg-grey p-4 p-md-6 rounded-3"></div>');
        }
        
        // Check if total text hasn't been changed yet
        if ($('.wc-block-components-totals-footer-item .wc-block-components-totals-item__label').text() !== 'Total') {
          $('.wc-block-components-totals-footer-item .wc-block-components-totals-item__label').text('Total');
        }

        // Check if payment description hasn't been added yet
        if ($('.wc-block-checkout__payment-method .wc-block-components-checkout-step__description').length === 0) {
          $('.wc-block-checkout__payment-method .wc-block-components-checkout-step__container').prepend('<p class="wc-block-components-checkout-step__description">All transactions are secure and encrypted. Choose your preferred payment method.</p>');
        }

        // Check if button text hasn't been changed yet
        if ($('.wc-block-checkout__actions .wc-block-components-checkout-place-order-button__text').text() !== 'Place Secure Order') {
          $('.wc-block-checkout__actions .wc-block-components-checkout-place-order-button__text').text('Place Secure Order');
        }
      }, 500);
    }

    // Persist the user's Sort By + Show X per page choices across category
    // navigation. Writes a cookie that the server reads back via the
    // loop_shop_per_page / woocommerce_default_catalog_orderby filters
    // (see inc/woocommerce-functions.php — ACITY_SHOP_*_COOKIE). 1-year
    // lifetime so the preference also survives across sessions.
    var ACITY_SHOP_PREF_MAX_AGE = 60 * 60 * 24 * 365;
    function setShopPrefCookie(name, value) {
      document.cookie = name + '=' + encodeURIComponent(value) +
        '; path=/; max-age=' + ACITY_SHOP_PREF_MAX_AGE + '; SameSite=Lax';
    }

    // Delegated (not direct) binding: the select lives inside WCAPF's
    // `.wcapf-before-products` wrapper, which WCAPF re-renders via AJAX on
    // every filter interaction. A direct .change() binding dies with the
    // replaced element — the rebuilt dropdown then "does nothing" (Monday
    // post-launch pulses/12309405260, reported on search but equally true
    // on category archives after filtering).
    $(document).on('change', '#product-per-page-select', function() {
      var selectedValue = $(this).val();
      var currentUrl = window.location.href;
      var newUrl;

      setShopPrefCookie('acity_shop_per_page', selectedValue);

      // Check if URL already has query parameters
      if (currentUrl.indexOf('?') !== -1) {
        // URL has query parameters
        if (currentUrl.indexOf('product-per-page=') !== -1) {
          // Replace existing product-per-page parameter
          newUrl = currentUrl.replace(/product-per-page=[^&]*/, 'product-per-page=' + selectedValue);
        } else {
          // Add product-per-page parameter
          newUrl = currentUrl + '&product-per-page=' + selectedValue;
        }
      } else {
        // URL has no query parameters
        newUrl = currentUrl + '?product-per-page=' + selectedValue;
      }

      // Redirect to new URL
      window.location.href = newUrl;
    });

    // Sort By — WooCommerce's own frontend.js binds a delegated change
    // handler at .woocommerce-ordering that submits the form. Delegated
    // handlers on closer ancestors fire before those on document, so a
    // jQuery $(document).on() handler would lose the race and our cookie
    // would be written after navigation was already queued. We use a
    // native capture-phase listener instead, which runs before any
    // bubble-phase handler regardless of where it's attached.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('select.orderby')) {
        setShopPrefCookie('acity_shop_orderby', t.value);
      }
    }, true);

    // Cover users landing on URLs that explicitly carry these params —
    // e.g. shared / bookmarked links. Keep the cookie aligned with the
    // active state so subsequent category nav uses what they're seeing.
    (function syncShopPrefCookiesFromUrl() {
      var params = new URLSearchParams(window.location.search);
      var pp = params.get('product-per-page');
      var ob = params.get('orderby');
      if (pp) setShopPrefCookie('acity_shop_per_page', pp);
      if (ob) setShopPrefCookie('acity_shop_orderby', ob);
    })();

    // Fixing Cart / Checkout Woo Images
    let startTime = Date.now();
    let maxTime = 5000; // 5 seconds
    let interval = 300; // Check every 300ms

    let processed = new WeakSet(); // To avoid reprocessing the same images

    let checkImages = function() {
      const now = Date.now();
      if (now - startTime > maxTime) {
        clearInterval(timer);
        return;
      }

      const selectors = [
        '.wc-block-components-order-summary-item__image img',
        '.related-products-slider img',
        '.related-products-slider .slick-slide .product-image img',
        '.wc-block-cart-item__image img'
      ];

      selectors.forEach(selector => {
        $(selector).each(function() {
          if (processed.has(this)) return;

          const src = $(this).attr('src');
          // Match any dimension pattern like -251x300, -300x300, -150x150, etc.
          if (src && /-\d+x\d+\.\w{3,4}$/.test(src)) {
            const newSrc = src.replace(/-\d+x\d+(\.\w{3,4})$/, '$1');
            $(this).attr('src', newSrc);
            processed.add(this);
          }
        });
      });
    };

    let timer = setInterval(checkImages, interval);

    // Layout preference
    //
    // Mobile (<769px) is force-pinned to grid because the list-layout's
    // wide card uses a horizontal col-3/col-9 split that doesn't degrade
    // well on narrow viewports. Desktop respects the user's saved
    // preference (localStorage primary, cookie kept in sync for SSR);
    // on first visit (no stored pref) we default to list-layout per design.
    function getLayoutPreference() {
      try {
        var stored = window.localStorage.getItem('layout_preference');
        if (stored === 'list' || stored === 'grid') return stored;
      } catch (e) { /* localStorage unavailable */ }
      return getCookie('layout_preference');
    }

    function setLayoutPreference(value) {
      try {
        window.localStorage.setItem('layout_preference', value);
      } catch (e) { /* localStorage unavailable */ }
      // Cookie kept in sync so SSR (loop-start.php) matches first paint.
      document.cookie = "layout_preference=" + value + "; path=/; max-age=" + (30 * 24 * 60 * 60); // 30 days
    }

    function layoutCookie() {
      var layoutPreference = null;

      if ($(window).width() < 769) {
        layoutPreference = 'grid';
      } else {
        var stored = getLayoutPreference();
        layoutPreference = (stored === 'grid' || stored === 'list') ? stored : 'list';
      }

      $('.view-toggle').each(function(){
        var button = $(this);
        var layoutValue = button.data('layout');

        // toggleClass keeps the state self-consistent — without the
        // else-remove path a previously-active button stayed active
        // when the preference flipped (e.g. user clicks Quick View on
        // page 1, paginates to page 2 — both toggles ended up
        // .active because the server-side render carries the new
        // active class and the JS only ever added).
        button.toggleClass('active', layoutValue == layoutPreference);
      });

      $('.wcapf-before-products .products').removeClass('columns-3 grid-layout list-layout').addClass(layoutPreference + '-layout');
    }

    function getCookie(name) {
      var value = "; " + document.cookie;
      var parts = value.split("; " + name + "=");
      if (parts.length == 2) return parts.pop().split(";").shift();
      return null;
    }

    $(document).on('click', '.view-toggle', function(e) {
      e.preventDefault();

      var button = $(this);
      var layoutValue = button.data('layout');

      $('.view-toggle').removeClass('active');

      button.addClass('active');

      setLayoutPreference(layoutValue);

      // Apply layout changes immediately
      $('.wcapf-before-products .products').removeClass('columns-3 grid-layout list-layout').addClass(layoutValue + '-layout');
    });

    $('[data-hex]').each(function() {
      var hexColor = $(this).data('hex');
      var rgb = hexToRgb(hexColor);

      if (rgb) {
        $(this).css({
          '--before-bg-r': rgb.r,
          '--before-bg-g': rgb.g,
          '--before-bg-b': rgb.b
        });
      }
    });

    $('#variation-select').on('change', function(){
      var selectedValue = $('#variation-select').val();
      var hexColor = $('#variation-select option:selected').data('colour');
      var $secondSelect = $('#pa_colour');
      var matchingOption = $secondSelect.find('option[value="' + selectedValue + '"]');

      var rgb = hexToRgb(hexColor);
      if (rgb) {
        $('[data-hex]').css({
          '--before-bg-r': rgb.r,
          '--before-bg-g': rgb.g,
          '--before-bg-b': rgb.b
        });
      }

      if (matchingOption.length > 0) {
        $secondSelect.val(selectedValue).trigger('change');
      }
    });

    function hexToRgb(hex) {
      if (!hex) return null;

      hex = hex.replace('#', '');

      return {
        r: parseInt(hex.substr(0, 2), 16),
        g: parseInt(hex.substr(2, 2), 16),
        b: parseInt(hex.substr(4, 2), 16)
      };
    }

    // Gallery Arrow Navigation
    var thumbGallery = {};

    setTimeout(function(){
      if($('.flex-control-nav').length > 0) {
        var mainImage = $('.flex-viewport');
        mainImage.append('<button type="button" class="gallery-nav nav-next"><i class="fa-solid fa-chevron-right"></i></button>');
        mainImage.prepend('<button type="button" class="gallery-nav nav-prev"><i class="fa-solid fa-chevron-left"></i></button>');

        // #14 — show ALL thumbnails in a back-and-forth scrollable strip
        // (was a paged "+N" model that hid overflow thumbs). The strip is a
        // horizontal scroll container (SCSS); the existing main-image
        // nav-prev/nav-next arrows still advance the active image, and we
        // scroll the active thumb into view as they do.
        var $thumbNav = $('.flex-control-nav');
        $thumbNav.addClass('ac-thumb-strip');
        $thumbNav.find('li').show();
        // Drop any legacy +N button left over from a prior render.
        $thumbNav.find('.thumb-page-btn').remove();

        // #10 (Beckie round 3) — flank the thumbnail strip with left/right
        // arrows so the client can cycle the thumbs. Wrap the strip once and
        // inject the arrows; the click handlers below scroll the strip. The
        // wrapper hides the arrows when every thumb already fits.
        if (!$thumbNav.parent().hasClass('ac-thumb-strip-wrap')) {
          $thumbNav.wrap('<div class="ac-thumb-strip-wrap"></div>');
          var $tWrap = $thumbNav.parent();
          $tWrap.prepend('<button type="button" class="ac-thumb-arrow ac-thumb-prev" aria-label="Scroll thumbnails left"><i class="fa-solid fa-chevron-left" aria-hidden="true"></i></button>');
          $tWrap.append('<button type="button" class="ac-thumb-arrow ac-thumb-next" aria-label="Scroll thumbnails right"><i class="fa-solid fa-chevron-right" aria-hidden="true"></i></button>');
        }
        thumbGallery.updateThumbArrowState = function () {
          $('.flex-control-nav.flex-control-thumbs').each(function () {
            var fits = this.scrollWidth <= this.clientWidth + 1;
            $(this).closest('.ac-thumb-strip-wrap').toggleClass('ac-no-overflow', fits);
          });
        };
        thumbGallery.updateThumbArrowState();

        $('.flex-control-nav li img.flex-active').parent('li').addClass('active-li');

        // Scroll the given thumb into view within the strip (replaces the
        // old paging). Keeps the active thumb visible as the user steps
        // through images with the main arrows.
        thumbGallery.showPageForThumb = function($thumbLi) {
          var el = $thumbLi && $thumbLi.get(0);
          if (el && el.scrollIntoView) {
            el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
          }
        };
      }

      removeImageDimensions();
    }, 250);

    // Document click handlers
    $(document).on('click', '.nav-next', function() {
      var $activeThumb = $('.flex-control-nav li img.flex-active');
      var $nextThumb = $activeThumb.closest('li').nextAll('li').first().find('img');

      $('.flex-control-nav li').removeClass('active-li');

      // If no next thumbnail, wrap to the first one
      if ($nextThumb.length === 0) {
        $nextThumb = $('.flex-control-nav li').first().find('img');
      }

      if ($nextThumb.length > 0) {
        $nextThumb.click();
        $nextThumb.parent('li').addClass('active-li');
        if (thumbGallery.showPageForThumb) {
          thumbGallery.showPageForThumb($nextThumb.closest('li'));
        }
      }
    });

    $(document).on('click', '.flex-control-nav li img', function() {
      $('.flex-control-nav li').removeClass('active-li');
      $(this).parent('li').addClass('active-li');
      if (thumbGallery.showPageForThumb) {
        thumbGallery.showPageForThumb($(this).closest('li'));
      }
    });

    $(document).on('click', '.nav-prev', function() {
      var $activeThumb = $('.flex-control-nav li img.flex-active');
      var $prevThumb = $activeThumb.closest('li').prevAll('li').first().find('img');

      $('.flex-control-nav li').removeClass('active-li');

      // If no previous thumbnail, wrap to the last one
      if ($prevThumb.length === 0) {
        $prevThumb = $('.flex-control-nav li').last().find('img');
      }
      
      if ($prevThumb.length > 0) {
        $prevThumb.click();
        $prevThumb.parent('li').addClass('active-li');
        if (thumbGallery.showPageForThumb) {
          thumbGallery.showPageForThumb($prevThumb.closest('li'));
        }
      }
    });

    // #10 — thumbnail-strip arrows: scroll/cycle the strip on click. Scrolls
    // ~80% of the visible width per click and wraps around at the ends so it
    // "cycles" (end -> start, start -> end). Scoped to the sibling strip.
    function ac_scrollThumbStrip(strip, dir) {
      if (!strip) return;
      var step = Math.max(strip.clientWidth * 0.8, 160);
      var max = strip.scrollWidth - strip.clientWidth;
      var target;
      if (dir > 0) target = (strip.scrollLeft >= max - 2) ? 0 : Math.min(max, strip.scrollLeft + step);
      else target = (strip.scrollLeft <= 2) ? max : Math.max(0, strip.scrollLeft - step);
      strip.scrollTo({ left: target, behavior: 'smooth' });
    }
    $(document).on('click', '.ac-thumb-next', function (e) {
      e.preventDefault();
      ac_scrollThumbStrip($(this).siblings('.flex-control-nav.flex-control-thumbs').get(0), 1);
    });
    $(document).on('click', '.ac-thumb-prev', function (e) {
      e.preventDefault();
      ac_scrollThumbStrip($(this).siblings('.flex-control-nav.flex-control-thumbs').get(0), -1);
    });
    $(window).on('resize', function () {
      if (thumbGallery.updateThumbArrowState) thumbGallery.updateThumbArrowState();
    });

    function removeImageDimensions() {
      $('img').each(function() {
        var $img = $(this);
        var src = $img.attr('src');
        
        if (src) {
          // Remove dimension suffixes like -300x300, -150x150, etc.
          var newSrc = src.replace(/-\d+x\d+(?=\.(jpg|jpeg|png|gif|webp))/i, '');
          
          if (newSrc !== src) {
            $img.attr('src', newSrc);
          }
        }

        if ($img.attr('srcset')) {
          $img.removeAttr('srcset');
        }
      });
    }

    function moveMultiBuyBtn() {
      if ($(window).width() < 1200) {
        $('.summary-sidebar .multi-buy-btn').prependTo('.woocommerce-variation-add-to-cart');
      } else {
        $('.summary-sidebar .multi-buy-btn').insertAfter('.cart');
      }
    }

    // Run on page load
    moveMultiBuyBtn();

    // Cart Delivery Change — save to WC session via AJAX
    var checkoutTypeRequest = null;

    function setCheckoutType(type) {
      if (checkoutTypeRequest) {
        checkoutTypeRequest.abort();
      }
      checkoutTypeRequest = $.ajax({
        url: ajax_object.ajax_url,
        type: 'POST',
        data: {
          action: 'set_checkout_type',
          checkout_type: type
        },
        complete: function() {
          checkoutTypeRequest = null;
        }
      });
    }

    // Set default on page load based on whichever radio is checked
    var $checkedDelivery = $('.delivery-type-option input[type="radio"]:checked');
    if ($checkedDelivery.length) {
      document.cookie = "checkout_type=" + $checkedDelivery.val() + "; path=/; max-age=" + (30 * 60);
      setCheckoutType($checkedDelivery.val());
    }

    $('.delivery-type-option input[type="radio"]').on('change', function() {
      var type = $(this).val();
      // Set cookie immediately so checkout page can read it without waiting for AJAX
      document.cookie = "checkout_type=" + type + "; path=/; max-age=" + (30 * 60); // 30 minutes
      setCheckoutType(type);
    });

    $('#deals-toggle').on('click', function () {
      // Reveal the next two hidden deal cards per click (incremental
      // "show more"), then hide the button once every deal is visible.
      var $btn = $(this);
      var hidden = $('.fbt-deal-card').filter(function () {
        return this.style.display === 'none';
      });
      var $revealed = hidden.slice(0, 2).css('display', 'block');

      // The mobile product list inside each deal card uses a Slick
      // carousel (.fbt-card-slider). Those carousels were initialised on
      // page load while their card was display:none, so Slick measured a
      // 0-width container and the slides stack/overlap when first shown.
      // Force each just-revealed slider to recalculate its layout now that
      // it is visible. (Same setPosition-after-reveal pattern used for the
      // deals tab carousels in scripts.js.) Defer to the next frame so the
      // display change has been applied before Slick re-measures.
      window.requestAnimationFrame(function () {
        $revealed.find('.fbt-card-slider, .fbt-card-wrapper--carousel').each(function () {
          var $slider = $(this);
          if ($slider.hasClass('slick-initialized')) {
            $slider.slick('setPosition');
          }
        });
      });

      var stillHidden = $('.fbt-deal-card').filter(function () {
        return this.style.display === 'none';
      });
      if (stillHidden.length === 0) {
        $btn.hide();
      }
    });

    // FBT Add To Basket
    $(document).on('click', '.fbt-add-to-basket', function(e) {
      e.preventDefault();

      var basketData = $(this).data('basket');

      $.ajax({
        url: ajax_object.ajax_url,
        type: 'POST',
        data: {
          action: 'frequently_bought_together',
          products: JSON.stringify(basketData),
          nonce: ajax_object.fbt_nonce
        },
        success: function(response) {
          if (response.success) {
            window.location.href = '/cart/';
          } else {
            alert('Error adding products to basket');
          }
        }
      });
    });

    // Product Page Postcode Delivery Check
    $('.postcode-checker button').on('click', function() {
      var $checker = $(this).closest('.postcode-checker');
      var $input = $checker.find('input');
      var postcode = $.trim($input.val());
      var productId = $checker.data('product-id');
      var $results = $checker.next('.postcode-checker-results');
      var $datesContainer = $results.find('.woocommerce-delivery-dates');
      var $btn = $(this);

      if (!postcode) {
        $datesContainer.html('<p class="small text-danger mb-0 px-2">Please enter a postcode.</p>');
        $results.removeClass('d-none');
        return;
      }

      $btn.prop('disabled', true).text('Checking...');
      $datesContainer.html('<p class="small text-muted px-2 mb-0">Loading available dates...</p>');
      $results.removeClass('d-none');

      $.ajax({
        url: ajax_object.ajax_url,
        type: 'POST',
        data: {
          action: 'check_product_delivery',
          postcode: postcode,
          product_id: productId
        },
        success: function(response) {
          // Remember the postcode the moment the server accepts it, not
          // only when bookable dates come back.
          //
          // This used to sit further down, behind three gates: not
          // out-of-stock, `dates` present, and at least one date actually
          // bookable. So an out-of-stock product, or a postcode with nothing
          // bookable in the window, saved nothing. That was invisible while
          // the next page auto-ran the lookup (no saved postcode simply meant
          // no auto-run), but now the saved value is the whole feature — it
          // is what prefills the box on the next product page. Oakley hit
          // exactly this on staging: the postcode was not there afterwards.
          //
          // `response.success` is the server telling us it understood the
          // postcode, so a typo that errors still saves nothing.
          // localStorage can throw in private browsing — ignore.
          if (response.success) {
            try { localStorage.setItem('ac_delivery_postcode', postcode); } catch (e) {}
          }

          // #28 — out-of-stock product: server returns an `oos` flag with a
          // "we'll be in touch" message instead of dates. Render it as an
          // informational note (tertiary/brand, not an error red).
          if (response.success && response.data && response.data.oos) {
            $datesContainer.html('<p class="small text-tertiary mb-0 px-2">' + response.data.message + '</p>');
            return;
          }

          if (response.success && response.data.dates) {
            // Bookable dates only: the API pads gap days (Sundays etc.) as
            // available:false placeholders, which would waste tiles and
            // render as dashes. Checkout's picker skips them too, so the
            // first 6 here always match checkout's first 6.
            var dates = response.data.dates.filter(function(d) {
              return d.available;
            }).slice(0, 6);

            if (dates.length === 0) {
              $datesContainer.html('<p class="small text-danger mb-0 px-2">No delivery dates available for ' + response.data.postcode + '.</p>');
              return;
            }

            var html = '';
            dates.forEach(function(date) {
              var priceText = date.available
                ? (date.delivery_charge > 0 ? '£' + date.delivery_charge.toFixed(2) : 'Free!')
                : '-';
              var unavailableClass = !date.available ? ' unavailable' : '';

              html += '<div class="col-4 mb-4 px-2 woocommerce-delivery-date-wrapper">';
              html += '<div class="text-center pdp-delivery-date-card' + unavailableClass + '">';
              html += '<p class="mb-2 h6 delivery-day d-flex align-items-center justify-content-center">' + date.day_name.substring(0, 3) + '</p>';
              html += '<p class="mb-1 small delivery-date">' + date.date_formatted.split(' ').slice(1).join(' ') + '</p>';
              html += '<p class="mb-0 small delivery-price fw-semibold">' + priceText + '</p>';
              html += '</div>';
              html += '</div>';
            });

            $datesContainer.html(html);
          } else {
            $datesContainer.html('<p class="small text-danger mb-0 px-2">' + (response.data.message || 'Unable to check delivery.') + '</p>');
          }
        },
        error: function() {
          $datesContainer.html('<p class="small text-danger mb-0 px-2">Something went wrong. Please try again.</p>');
        },
        complete: function() {
          $btn.prop('disabled', false).text('Check');
        }
      });
    });

    // Allow enter key to trigger postcode check
    $('.postcode-checker input').on('keypress', function(e) {
      if (e.which === 13) {
        e.preventDefault();
        $(this).closest('.postcode-checker').find('button').trigger('click');
      }
    });

    // Prefill the checker with the visitor's last successful postcode, but
    // do NOT run the lookup.
    //
    // This used to auto-trigger the visible checker's Check button on every
    // product page, so each PDP view fired a check_product_delivery AJAX
    // call straight through to NCompass. James flagged it at the QBR (17 Aug
    // 2026): the sales team move product to product all day, and every hop
    // was costing an availability call — "it seems to be making a call every
    // page that you go to". The request was for the result to stay on the
    // page where the postcode was entered.
    //
    // Prefill is kept so nobody retypes their postcode; one click still
    // gets the dates, and the server-side cache means that click is instant
    // if the same postcode/product pair was looked up recently. Both PDP
    // checker instances (mobile + desktop) are filled.
    (function () {
      var $checkers = $('.postcode-checker');
      if (!$checkers.length) return;

      var saved = '';
      try { saved = localStorage.getItem('ac_delivery_postcode') || ''; } catch (e) {}
      if (!saved) return;

      $checkers.each(function () {
        var $input = $(this).find('input');
        if (!$.trim($input.val())) {
          $input.val(saved);
        }
      });
    })();

    // #29 — when the CraftyClicks lookup fills a BUSINESS address, the org
    // name (e.g. "5 Lamps Media Ltd") is written into the hidden
    // #billing_company field; the visible address line 1 only receives the
    // building/street ("Woburn House"). Prepend the company name to line 1
    // so it reads "5 Lamps Media Ltd, Woburn House".
    //
    // This is NOT tied to the Residential/Business radio — CraftyClicks only
    // returns an org for genuine business premises, so it's self-gating: a
    // residential lookup leaves #billing_company empty and nothing is
    // prepended. (Earlier this required the Business radio to be ticked,
    // which meant it never fired unless the customer remembered to tick it.)
    (function () {
      var $addr1 = $('#billing_address_1');
      if (!$addr1.length) return; // not the checkout

      function prependCompanyToAddress() {
        var co = $.trim($('#billing_company').val() || '');
        if (!co) return;
        var val = $.trim($addr1.val() || '');
        // Idempotent — bail if the company name is already at the start.
        if (val.toLowerCase().indexOf(co.toLowerCase() + ',') === 0) return;
        $addr1.val(co + ', ' + val).trigger('change');
      }

      // CraftyClicks fires 'update' on #billing_address_1 after it fills the
      // fields (crafty-clicks .../js/checkout.js onResultSelected). It writes
      // #billing_company first, so the org is available here. Small delay to
      // be safe across the update sequence.
      $addr1.on('update', function () { setTimeout(prependCompanyToAddress, 50); });
    })();

    // Youreko empty-wrapper hider — Youreko is an async 3rd-party
    // script that injects an energy-review widget into
    // `.youreko-wrapper`. CSS `.youreko-wrapper:empty { display: none }`
    // (in scss/modules/_woocommerce.scss) handles the
    // cold-load / script-blocked case. This JS handles the case
    // where Youreko DOES inject something but it's only whitespace,
    // hidden nodes, or an empty iframe — so `:empty` no longer
    // matches but the wrapper still has no visible content and the
    // parent `gap-4` shows as a stray empty slot.
    //
    // We watch each wrapper for a settle window (no mutations for
    // 500ms after first observation, max 4s wait), then check if
    // it has any rendered content (non-empty text or any element
    // with a non-zero bounding box). If not → add `d-none`.
    $('.youreko-wrapper').each(function () {
      var wrapper = this;
      var settleTimer = null;
      var maxWaitTimer = null;

      function hasVisibleContent(el) {
        // Quick text-content check first.
        if ((el.textContent || '').trim() !== '') return true;
        // Then any element child with visible dimensions.
        var children = el.querySelectorAll('*');
        for (var i = 0; i < children.length; i++) {
          var rect = children[i].getBoundingClientRect();
          if (rect.width > 0 && rect.height > 0) return true;
        }
        return false;
      }

      function finalize() {
        if (!hasVisibleContent(wrapper)) {
          wrapper.classList.add('d-none');
        }
        if (observer) observer.disconnect();
        clearTimeout(settleTimer);
        clearTimeout(maxWaitTimer);
      }

      var observer = new MutationObserver(function () {
        clearTimeout(settleTimer);
        settleTimer = setTimeout(finalize, 500);
      });

      observer.observe(wrapper, { childList: true, subtree: true, characterData: true });

      // Hard cap: if Youreko never fires anything, run the check
      // once at 4s anyway so we don't leave a stray gap forever.
      maxWaitTimer = setTimeout(finalize, 4000);
    });

    // Energy-label modal — populate the shared #energyLabelModal's
    // image from the trigger's `data-energy-label-url` whenever a
    // product card's energy-rating button opens it. One modal handles
    // every card on the page; the trigger is the `relatedTarget` on
    // Bootstrap's `show.bs.modal` event.
    //
    // Clear the src on hide so the previous image doesn't briefly
    // flash when the next card's modal opens.
    $('#energyLabelModal').on('show.bs.modal', function (e) {
      var trigger = e.relatedTarget;
      if (!trigger) return;
      var url = trigger.getAttribute('data-energy-label-url') || '';
      var alt = trigger.getAttribute('data-energy-label-alt') || '';
      var $img = $(this).find('.energy-label-modal__image');
      $img.attr('src', url).attr('alt', alt);
    });
    $('#energyLabelModal').on('hidden.bs.modal', function () {
      $(this).find('.energy-label-modal__image').attr('src', '').attr('alt', '');
    });

    // Defensive: keep the click on the energy-rating button from
    // bubbling up to a wrapping card-link (some product card variants
    // wrap blocks in <a>). Without this, clicking the badge would
    // open the modal AND navigate to the product page in parallel.
    $(document).on('click', '.energy-rating-trigger', function (e) {
      e.stopPropagation();
    });

    // Product-video modal — sets the iframe src from the trigger's
    // `data-video-url` on open, clears it on hide so the video stops
    // playing when the modal closes. Same pattern as the
    // energy-label modal above. The trigger button is rendered just
    // under the gallery in content-single-product.php and only
    // appears when ac_get_youtube_embed_url() resolves the ACF
    // `tdl_video_review` value to a valid YouTube embed URL.
    $('#productVideoModal').on('show.bs.modal', function (e) {
      var trigger = e.relatedTarget;
      if (!trigger) return;
      var url = trigger.getAttribute('data-video-url') || '';
      $(this).find('.product-video-modal__iframe').attr('src', url);
    });
    $('#productVideoModal').on('hidden.bs.modal', function () {
      // Setting to empty halts YouTube playback — pausing via the
      // iframe API would need postMessage plumbing we don't have.
      $(this).find('.product-video-modal__iframe').attr('src', '');
    });

    // Manufacturer Information — FlixMedia primary, LoadBee fallback.
    //
    // The FlixMedia loader is emitted as a STATIC (parser-inserted,
    // deferred) <script> by content-single-product.php — NOT injected
    // from here. FlixMedia's loader reads its config from its own script
    // tag via document.currentScript, which is null for a JS-injected
    // script, so injecting it made the loader fail silently and render
    // nothing (proven on prod, 24 Aug 2026). As a static script it reads
    // its config and renders into #flix-inpage on page load, even inside
    // this collapsed (display:none) accordion.
    //
    // This block only decides show/hide + the LoadBee fallback, using
    // FlixMedia's own callbacks:
    //   inpage  → Flix has content: reveal the accordion.
    //   noshow  → Flix has nothing: try LoadBee (fallback).
    //   neither → backstops: DOM check for a missed inpage callback, then
    //             a safety timeout that falls back to LoadBee.
    // LoadBee is detected off-screen (its iframe won't mount in a
    // display:none collapse) and, on content, loaded into the visible
    // accordion body when the user first opens it.
    (function () {
      var $accordionItem = $('#tdm-mi-accordion-item');
      var $section       = $('#flush-collapse-manufacturer-information');
      var $container     = $section.find('.ac-manufacturer-info');
      if (!$accordionItem.length || !$section.length || !$container.length) return;

      var ean     = String($container.attr('data-ac-mi-ean')      || '').trim();
      var brand   = String($container.attr('data-ac-mi-brand')    || '').trim();
      var sku     = String($container.attr('data-ac-mi-sku')      || '').trim();
      var hasFlix = String($container.attr('data-ac-mi-has-flix') || '').trim() === '1';
      // BSH (Bosch/NEFF/Siemens): FlixMedia ONLY — LoadBee is never
      // loaded on these brands (explicit client + FlixMedia request). If
      // Flix has no content the section is removed; there is no LoadBee
      // fallback on this path.
      var isBsh   = String($container.attr('data-ac-mi-bsh')      || '').trim() === '1';

      // Nothing to key on at all → no section.
      if (!ean && !brand && !sku) { $accordionItem.remove(); return; }

      var settled = false; // final show/hide decision made

      // When FlixMedia has nothing: LoadBee fallback for non-BSH brands,
      // but remove the section entirely for BSH (no LoadBee, ever).
      function flixEmptyFallback() {
        if (isBsh) { removeSection(); return; }
        loadbeeFallback();
      }

      function reveal() {
        if (settled) return; settled = true;
        $accordionItem.removeClass('tdm-mi-pending').css('display', '');
      }
      function removeSection() {
        if (settled) return; settled = true;
        $accordionItem.remove();
      }

      // Build a LoadBee mount div for the given container.
      function makeLoadbee() {
        return $('<div>')
          .addClass('loadbeeTabContent')
          .attr('data-loadbee-apikey', 'hdRLWFMn65XtLH56ytxf7s3DmyAhamwk')
          .attr('data-loadbee-gtin', ean)
          .attr('data-loadbee-locale', 'en_GB')
          .attr('data-loadbee-debug', 'false');
      }
      function loadLoadbeeScript() {
        var s = document.createElement('script');
        s.async = true;
        s.src = 'https://cdn.loadbee.com/js/loadbee_integration.js';
        document.body.appendChild(s);
      }

      // LoadBee fallback (Flix returned noshow, or its loader failed).
      // LoadBee renders only ONE widget per page and its iframe won't
      // mount inside a display:none collapse, so we detect in an
      // off-screen (but rendered) probe, then — on content — reveal and
      // load a fresh LoadBee into the visible accordion body on first
      // open. The probe is removed before that second load so LoadBee's
      // "one widget per page" rule is satisfied.
      function loadbeeFallback() {
        if (settled) return;
        if (!ean) { removeSection(); return; } // LoadBee keys on GTIN/EAN

        var $probe = $('<div>')
          .attr('aria-hidden', 'true')
          .css({ position: 'absolute', left: '-9999px', top: '0', width: '320px', height: '320px', overflow: 'hidden', pointerEvents: 'none' })
          .appendTo('body');
        var $lb = makeLoadbee();
        $probe.append($lb);
        loadLoadbeeScript();

        var attempts = 0;
        var timer = setInterval(function () {
          attempts++;
          if ($lb[0].children.length > 0) {
            clearInterval(timer);
            $probe.remove();
            revealWithLoadbee();
            return;
          }
          if (attempts >= 12) { // 12 × 500ms = 6s
            clearInterval(timer);
            $probe.remove();
            removeSection();
          }
        }, 500);
      }

      // LoadBee has content: reveal the section and mount LoadBee into
      // the visible accordion body when it is first opened (fresh mount
      // in a visible context).
      function revealWithLoadbee() {
        reveal();
        var loaded = false;
        var load = function () {
          if (loaded) return; loaded = true;
          $container.find('.ac-mi-loadbee').empty().append(makeLoadbee());
          loadLoadbeeScript();
        };
        $section.one('shown.bs.collapse', load);
        if ($section.hasClass('show')) load();
      }

      // No Flix loader on the page (no brand / identifier). Non-BSH →
      // LoadBee; BSH → no section (never LoadBee).
      if (!hasFlix) { flixEmptyFallback(); return; }

      // Flix loader is present (static). Register its callbacks as soon
      // as flixJsCallbacks is defined — before Flix makes its decision.
      // The loader is a deferred parser-inserted script, so it runs just
      // before DOMContentLoaded and we register (on jQuery ready) well
      // inside its ~1–3s content decision — the callbacks are the
      // authoritative inpage/noshow signal.
      //   inpage → Flix has content, already rendering into #flix-inpage.
      //   noshow → Flix has nothing for this product → LoadBee fallback.
      var flixDecided = false;
      var regTimer = setInterval(function () {
        var fjc = window.flixJsCallbacks;
        if (fjc && typeof fjc.setLoadCallback === 'function') {
          clearInterval(regTimer);
          fjc.setLoadCallback(function () {
            if (flixDecided) return; flixDecided = true;
            clearTimeout(safety);
            reveal();
          }, 'inpage');
          fjc.setLoadCallback(function () {
            if (flixDecided) return; flixDecided = true;
            clearTimeout(safety);
            flixEmptyFallback();
          }, 'noshow');
        }
      }, 50);

      // Safety net: neither callback fired within a generous window
      // (Flix loader error / network failure). Non-BSH → LoadBee so the
      // section is never left pending; BSH → remove it (never LoadBee).
      var safety = setTimeout(function () {
        clearInterval(regTimer);
        if (!flixDecided) { flixDecided = true; flixEmptyFallback(); }
      }, 12000);
    })();

    // Wishlist Classes
    // Replace wishlist span content with Font Awesome heart icon
    var updatingWishlist = false;
    function updateWishlistIcons() {
      if (updatingWishlist) return;
      updatingWishlist = true;
      $('.icon_after_add_to_cart a span.wt-wishlist-button').each(function() {
        var $span = $(this);
        var expectedHtml = $span.hasClass('webtoffee_wishlist_remove')
          ? '<i class="fa-solid fa-heart"></i>'
          : '<i class="fa-regular fa-heart"></i>';
        // Only update if the content doesn't already match, to avoid triggering the observer
        if ($span.html() !== expectedHtml) {
          $span.html(expectedHtml);
        }
      });
      updatingWishlist = false;
    }

    // Run on page load
    updateWishlistIcons();

    // Watch for plugin DOM mutations and re-apply icons
    var wishlistDebounce;
    var wishlistObserver = new MutationObserver(function() {
      clearTimeout(wishlistDebounce);
      wishlistDebounce = setTimeout(updateWishlistIcons, 50);
    });
    $('.icon_after_add_to_cart').each(function() {
      wishlistObserver.observe(this, { childList: true, subtree: true, characterData: true });
    });

    // Re-apply wishlist icons after any AJAX request (filtering, wishlist updates, etc.)
    $(document).ajaxComplete(function() {
      setTimeout(updateWishlistIcons, 100);
    });

    // Update icon and classes on wishlist button click
    $(document).on('click', '.icon_after_add_to_cart .wt-wishlist-button', function() {
      var $container = $(this).closest('.icon_after_add_to_cart');
      var $span = $container.find('a span.wt-wishlist-button');
      var isInWishlist = $span.hasClass('webtoffee_wishlist_remove');

      // Toggle the class and icon immediately for visual feedback
      if (isInWishlist) {
        $span.removeClass('webtoffee_wishlist_remove').addClass('webtoffee_wishlist');
        $span.html('<i class="fa-regular fa-heart"></i>');
      } else {
        $span.removeClass('webtoffee_wishlist').addClass('webtoffee_wishlist_remove');
        $span.html('<i class="fa-solid fa-heart"></i>');
      }
    });

    // PayPal Pay Later / Pay-in-3 messaging now sits in light boxes (purple
    // border) on both the basket and single product pages, so it keeps PayPal's
    // default black text everywhere. forcePayLaterWhite() used to flip it to
    // white for the old dark panels and is no longer called (kept below for
    // reference in case a dark panel is ever reintroduced).

    // Wishlist page - remove product card when remove button clicked
    $(document).on('click', '.remove-from-wishlist .remove_wishlist_single', function(e) {
      e.preventDefault();
      var $card = $(this).closest('.wishlist-product-item');
      $card.fadeOut(300, function() {
        $(this).remove();
        // Check if wishlist is now empty
        if ($('.wishlist-product-item').length === 0) {
          location.reload();
        }
      });
    });
  }
};
function forcePayLaterWhite() {
  var SELECTOR = '[data-pp-style-text-color="black"]';

  function swap(el) {
    if (el && el.getAttribute('data-pp-style-text-color') === 'black') {
      el.setAttribute('data-pp-style-text-color', 'white');
    }
  }

  // Initial pass for any wrappers already in the DOM.
  document.querySelectorAll(SELECTOR).forEach(swap);

  // PayPal's SDK injects/updates the messaging wrapper asynchronously, so
  // keep watching for new black wrappers and any attribute flip back to
  // black (e.g. on a re-render).
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      if (m.type === 'attributes' && m.attributeName === 'data-pp-style-text-color') {
        swap(m.target);
      } else if (m.type === 'childList') {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(SELECTOR)) swap(node);
          if (node.querySelectorAll) {
            node.querySelectorAll(SELECTOR).forEach(swap);
          }
        });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-pp-style-text-color']
  });
}

/**
 * Checkout phone: show the customer the number we will actually store.
 *
 * The server normalises +44 / 0044 / bare-44 entries to 07XXXXXXXXX before the
 * order is written (acity_normalise_checkout_phones), because validating them
 * without rewriting them is what let 447904857628 reach NCompass and break the
 * delivery texts. Mirroring it on blur means the field matches what gets saved
 * instead of silently changing after submission.
 */
jQuery(function ($) {
  function normaliseUkMobile(raw) {
    var d = String(raw).replace(/\D+/g, '');
    if (!d) { return ''; }
    if (d.indexOf('0044') === 0)                      { d = '0' + d.slice(4); }
    else if (d.indexOf('440') === 0 && d.length === 13) { d = d.slice(2); }
    else if (d.indexOf('44') === 0 && d.length === 12)  { d = '0' + d.slice(2); }
    else if (d.indexOf('7') === 0 && d.length === 10)   { d = '0' + d; }
    return /^07\d{9}$/.test(d) ? d : '';
  }

  // Exposed so the checkout step-1 Continue validation (form-checkout.php)
  // can accept exactly what the server accepts, rather than duplicating this
  // logic as a second, driftable copy.
  window.acity = window.acity || {};
  window.acity.normaliseUkMobile = normaliseUkMobile;

  $(document).on('blur', '#billing_phone, #shipping_phone', function () {
    var tidy = normaliseUkMobile(this.value);
    if (tidy && tidy !== this.value) {
      this.value = tidy;
      $(this).trigger('change');
    }
  });
});

/**********************************************************/
/* WooCommerce JS End *************************************/
/**********************************************************/